  const ships = [
    {
      "primary_toggle": true,
      "primary_y": -10,
      "primary_z": 0.5,
      "primary_radius": 12,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 0.75,
      "sublight_toggle": true,
      "sublight_y": 11.98,
      "sublight_x": 1.33,
      "sublight_z": -2.5,
      "sublight_length": 6,
      "sublight_radius": 0.55,
      "sublight_widthRatio": 6.25,
      "sublight_rotation": 0,
      "sublight_segments": 4,
      "sublight_skewVertical": 0,
      "sublight_skewHorizontal": 0.56,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 0.3,
      "neck_thickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -28.9,
      "engineering_z": 7.6,
      "engineering_length": 15.3,
      "engineering_radius": 2.35,
      "engineering_widthRatio": 1,
      "engineering_skew": -0.68,
      "engineering_undercut": 0.74,
      "engineering_undercutStart": 0.02,
      "engineering_undercutCurve": 1.75,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 26.5,
      "nacelle_x": 3.4,
      "nacelle_z": -0.8,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 0.37,
      "nacelle_rotation": 0,
      "nacelle_skew": -0.82,
      "nacelle_undercutStart": 0.53,
      "nacelle_undercut": 0.75,
      "nacelle_bussardWidthRatio": 2.05,
      "nacelle_bussardRadius": 0.99,
      "nacelle_bussardCurvature": 1.13,
      "nacelle_bussardSkewVertical": -0.71,
      "nacelle_bussardYOffset": -0.81,
      "nacelle_bussardZOffset": -0.39,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.45,
      "pylon_engineeringForeOffset": 0.11,
      "pylon_engineeringAftOffset": 0.73,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.21,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 5,
      "nacelleLower_x": 2.5,
      "nacelleLower_z": -3.5,
      "nacelleLower_length": 12,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.15,
      "name": "Defaultant Refit",
      "nacelleLower_bussardYOffset": null,
      "nacelleLower_bussardSkewVertical": null,
      "notchAngleAft": null
    },
    {
      "name": "Defaultant",
      "nacelle_toggle": true,
      "nacelle_y": 26.5,
      "nacelle_x": 3.4,
      "nacelle_z": -0.8,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "boomLower_toggle": false,
      "engineering_toggle": true,
      "engineering_y": -28.9,
      "engineering_z": 7.6,
      "engineering_length": 15.3,
      "engineering_radius": 1.8,
      "engineering_widthRatio": 1,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishInset": 0.0,
      "engineering_dishRadius": 1.0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.45,
      "pylon_engineeringForeOffset": 0.56,
      "pylon_engineeringAftOffset": 0.19,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.4,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.3,
      "neck_primaryThickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -10,
      "primary_z": 0.5,
      "primary_radius": 12,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
    },
    {
      "primary_toggle": true,
      "primary_y": -2.22,
      "primary_z": 3.62,
      "primary_radius": 9.4,
      "primary_thickness": 2.62,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.04,
      "primary_bridgeRadius": 0.9,
      "primary_bridgeWidthRatio": 0.49,
      "primary_bridgeZ": 0.03,
      "primary_bridgeY": 0.06,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 0.59,
      "sublight_toggle": true,
      "sublight_y": -1.65,
      "sublight_x": 0.9,
      "sublight_z": -4.61,
      "sublight_length": 10.44,
      "sublight_radius": 0.69,
      "sublight_widthRatio": 5.1,
      "sublight_rotation": 0.05,
      "sublight_segments": 3,
      "sublight_skewVertical": -1.24,
      "sublight_skewHorizontal": 0.01,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.57,
      "neck_primaryAftOffset": -0.15,
      "neck_engineeringForeOffset": 0.11,
      "neck_engineeringAftOffset": 0.45,
      "neck_primaryThickness": 1.64,
      "neck_thickness": 2.45,
      "neck_foretaper": 0.24,
      "neck_afttaper": 0.05,
      "engineering_toggle": true,
      "engineering_y": -19.01,
      "engineering_z": 6.21,
      "engineering_length": 20.86,
      "engineering_radius": 1.89,
      "engineering_widthRatio": 0.63,
      "engineering_skew": -0.83,
      "engineering_undercut": 0.77,
      "engineering_undercutStart": 0.37,
      "engineering_undercutCurve": 9.3,
      "engineering_dishRadius": 0.72,
      "engineering_dishInset": 0.91,
      "nacelle_toggle": true,
      "nacelle_y": 19.01,
      "nacelle_x": 3.83,
      "nacelle_z": -3.09,
      "nacelle_length": 17.7,
      "nacelle_radius": 1,
      "nacelle_widthRatio": 0.79,
      "nacelle_rotation": -0.33,
      "nacelle_skew": -1.5,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.51,
      "nacelle_bussardWidthRatio": 0.48,
      "nacelle_bussardRadius": 1.21,
      "nacelle_bussardCurvature": 1.63,
      "nacelle_bussardSkewVertical": 0.53,
      "nacelle_bussardYOffset": 0.84,
      "nacelle_bussardZOffset": -0.43,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.35,
      "pylon_engineeringForeOffset": 0.14,
      "pylon_engineeringAftOffset": 0.56,
      "pylon_engineeringZOffset": 1,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.11,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 21.12,
      "nacelleLower_x": -3.84,
      "nacelleLower_z": 3.1,
      "nacelleLower_length": 9.85,
      "nacelleLower_radius": 1.11,
      "nacelleLower_widthRatio": 0.6,
      "nacelleLower_rotation": -0.08,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.29,
      "nacelleLower_undercut": 0.8,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.04,
      "pylonLower_nacelleAftOffset": 0.53,
      "pylonLower_engineeringForeOffset": 0.81,
      "pylonLower_engineeringAftOffset": 0.04,
      "pylonLower_engineeringZOffset": -0.18,
      "pylonLower_midPointOffset": 0.52,
      "pylonLower_thickness": 0.13,
      "name": "Swansea Bay V",
      "nacelle_lowerToggle": false,
      "primary_segments": 64,
      "primary_bridgeSegments": 64,
      "nacelleLower_bussardYOffset": null,
      "nacelleLower_bussardSkewVertical": null,
      "notchAngleAft": null
    },
    {
      "primary_toggle": true,
      "primary_y": -9.15,
      "primary_z": 0.5,
      "primary_radius": 12,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1,
      "primary_bridgeRadius": 0.36,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 1.24,
      "sublight_toggle": true,
      "sublight_y": 9.78,
      "sublight_x": 2.02,
      "sublight_z": -2.19,
      "sublight_length": 6,
      "sublight_radius": 0.4,
      "sublight_widthRatio": 10,
      "sublight_rotation": -0.02,
      "sublight_segments": 3,
      "sublight_skewVertical": -0.17,
      "sublight_skewHorizontal": 0.71,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": -0.17,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 1.56,
      "neck_thickness": 0.3,
      "neck_foretaper": 0.97,
      "neck_afttaper": 0.47,
      "engineering_toggle": true,
      "engineering_y": -21.12,
      "engineering_z": 5.12,
      "engineering_length": 11.61,
      "engineering_radius": 1.42,
      "engineering_widthRatio": 2.15,
      "engineering_skew": -0.68,
      "engineering_undercut": 0.56,
      "engineering_undercutStart": 0.32,
      "engineering_undercutCurve": 4.53,
      "engineering_dishRadius": 0.83,
      "engineering_dishInset": 0.46,
      "nacelle_toggle": true,
      "nacelle_y": 10.09,
      "nacelle_x": 3.41,
      "nacelle_z": -2.66,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.8,
      "nacelle_widthRatio": 0.37,
      "nacelle_rotation": -0.32,
      "nacelle_skew": -0.82,
      "nacelle_undercutStart": 0.53,
      "nacelle_undercut": 0.67,
      "nacelle_bussardWidthRatio": 2.05,
      "nacelle_bussardRadius": 0.89,
      "nacelle_bussardCurvature": 1.13,
      "nacelle_bussardSkewVertical": 0.71,
      "nacelle_bussardYOffset": 3.21,
      "nacelle_bussardZOffset": -0.39,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.62,
      "pylon_engineeringForeOffset": 0.23,
      "pylon_engineeringAftOffset": 0.65,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.21,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 5,
      "nacelleLower_x": 2.5,
      "nacelleLower_z": -3.5,
      "nacelleLower_length": 12,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.15,
      "name": "Shaggy Rug V",
      "nacelle_lowerToggle": false,
      "primary_segments": 64,
      "primary_bridgeSegments": 64,
      "notchAngleAft": null
    },
    {
      "primary_toggle": true,
      "primary_y": -5.31,
      "primary_z": 1.51,
      "primary_radius": 12,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.16,
      "primary_bridgeRadius": 0.17,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.01,
      "primary_bridgeY": 0.02,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 0.62,
      "sublight_toggle": true,
      "sublight_y": 6.53,
      "sublight_x": 1.07,
      "sublight_z": -2.77,
      "sublight_length": 11.48,
      "sublight_radius": 0.92,
      "sublight_widthRatio": 2.75,
      "sublight_rotation": 0,
      "sublight_segments": 4,
      "sublight_skewVertical": 1.11,
      "sublight_skewHorizontal": 0.2,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.57,
      "neck_primaryAftOffset": -0.09,
      "neck_engineeringForeOffset": 0.11,
      "neck_engineeringAftOffset": 0.58,
      "neck_primaryThickness": 5,
      "neck_thickness": 3.73,
      "neck_foretaper": 0.02,
      "neck_afttaper": 0.53,
      "engineering_toggle": true,
      "engineering_y": -35.7,
      "engineering_z": 7.81,
      "engineering_length": 26.73,
      "engineering_radius": 2.74,
      "engineering_widthRatio": 1.02,
      "engineering_skew": -0.83,
      "engineering_undercut": 1,
      "engineering_undercutStart": 0.29,
      "engineering_undercutCurve": 6.64,
      "engineering_dishRadius": 0.71,
      "engineering_dishInset": 0.98,
      "nacelle_toggle": true,
      "nacelle_y": 22.62,
      "nacelle_x": 3.4,
      "nacelle_z": -3.27,
      "nacelle_length": 26.98,
      "nacelle_radius": 0.93,
      "nacelle_widthRatio": 1.64,
      "nacelle_rotation": 0,
      "nacelle_skew": -0.04,
      "nacelle_undercutStart": 0.69,
      "nacelle_undercut": 0.51,
      "nacelle_bussardWidthRatio": 0.44,
      "nacelle_bussardRadius": 1.34,
      "nacelle_bussardCurvature": 2.73,
      "nacelle_bussardSkewVertical": 0.64,
      "nacelle_bussardYOffset": -0.92,
      "nacelle_bussardZOffset": -0.27,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": -0.06,
      "pylon_nacelleAftOffset": 0.81,
      "pylon_engineeringForeOffset": 0.67,
      "pylon_engineeringAftOffset": 0.2,
      "pylon_engineeringZOffset": -1.24,
      "pylon_midPointOffset": 0.99,
      "pylon_thickness": 0.29,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 16.71,
      "nacelleLower_x": 0.37,
      "nacelleLower_z": 6.71,
      "nacelleLower_length": 8.8,
      "nacelleLower_radius": 3.48,
      "nacelleLower_widthRatio": 0.15,
      "nacelleLower_rotation": -1.56,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.29,
      "nacelleLower_undercut": 0.8,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.48,
      "pylonLower_engineeringForeOffset": 0,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.34,
      "pylonLower_thickness": 0.01,
      "name": "DeuxMilleNX",
      "notchAngleAft": null,
      "nacelle_lowerToggle": false,
      "primary_segments": 64,
      "primary_bridgeSegments": 64
    },
    {
      "primary_toggle": true,
      "primary_y": -1.45,
      "primary_z": -0.86,
      "primary_radius": 10.48,
      "primary_thickness": 6.29,
      "primary_widthRatio": 0.65,
      "primary_pointiness": 0.85,
      "primary_bridgeThickness": 0.7,
      "primary_bridgeRadius": 1.14,
      "primary_bridgeWidthRatio": 0.53,
      "primary_bridgeZ": -0.04,
      "primary_bridgeY": -0.19,
      "primary_notchAngle": 0.21,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.37,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 0.99,
      "neck_thickness": 0.42,
      "neck_foretaper": 0.43,
      "neck_afttaper": 0.65,
      "engineering_toggle": true,
      "engineering_y": -15.45,
      "engineering_z": 2.86,
      "engineering_length": 25.84,
      "engineering_radius": 2.71,
      "engineering_widthRatio": 0.56,
      "engineering_skew": -1.31,
      "engineering_undercut": 0.57,
      "engineering_undercutStart": 0.13,
      "engineering_undercutCurve": 3.99,
      "engineering_dishRadius": 0.97,
      "engineering_dishInset": 0.31,
      "nacelle_toggle": true,
      "nacelle_y": 11.69,
      "nacelle_x": 2.45,
      "nacelle_z": 2.53,
      "nacelle_length": 11.04,
      "nacelle_radius": 1.4,
      "nacelle_widthRatio": 0.95,
      "nacelle_rotation": -0.01,
      "nacelle_undercutStart": 0.16,
      "nacelle_undercut": 0.56,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.46,
      "pylon_nacelleAftOffset": 0.48,
      "pylon_engineeringForeOffset": 0.43,
      "pylon_engineeringAftOffset": 0.15,
      "pylon_engineeringZOffset": -1.18,
      "pylon_midPointOffset": 0.52,
      "pylon_thickness": 0.23,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 4.66,
      "nacelleLower_x": 5.38,
      "nacelleLower_z": 2.67,
      "nacelleLower_length": 14.61,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 0.85,
      "nacelleLower_rotation": -0.16,
      "nacelleLower_undercutStart": 0.26,
      "nacelleLower_undercut": 0.43,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": -0.14,
      "pylonLower_nacelleAftOffset": 0.46,
      "pylonLower_engineeringForeOffset": 0.91,
      "pylonLower_engineeringAftOffset": -0.05,
      "pylonLower_engineeringZOffset": -3.56,
      "pylonLower_midPointOffset": 0.51,
      "pylonLower_thickness": 0.22,
      "name": "Nerd of Prey II",
      "nacelle_lowerToggle": false,
      "engineering_segments": 36,
      "nacelle_segments": 36,
      "nacelle_skew": 0,
      "nacelleLower_segments": 36,
      "nacelleLower_skew": 0,
      "primary_segments": 27.55,
      "primary_bridgeSegments": 27.55
    },
    {
      "primary_toggle": true,
      "primary_y": -6.72,
      "primary_z": 0.43,
      "primary_radius": 8.61,
      "primary_thickness": 5.35,
      "primary_widthRatio": 0.97,
      "primary_pointiness": 0.85,
      "primary_bridgeThickness": 0.44,
      "primary_bridgeRadius": 0.64,
      "primary_bridgeWidthRatio": 0.62,
      "primary_bridgeZ": 0.1,
      "primary_bridgeY": -0.11,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": -0.15,
      "neck_engineeringForeOffset": 0.6,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 1.31,
      "neck_thickness": 0.16,
      "neck_foretaper": 0.75,
      "neck_afttaper": 0.53,
      "engineering_toggle": true,
      "engineering_y": -20.25,
      "engineering_z": -0.33,
      "engineering_length": 8.13,
      "engineering_radius": 1.2,
      "engineering_widthRatio": 2.95,
      "engineering_skew": 0.7,
      "engineering_undercut": 0.53,
      "engineering_undercutStart": 0.29,
      "engineering_undercutCurve": 3.53,
      "engineering_dishRadius": 0.89,
      "engineering_dishInset": 0.42,
      "nacelle_toggle": true,
      "nacelle_y": 11.26,
      "nacelle_x": 4.7,
      "nacelle_z": -0.43,
      "nacelle_length": 14.58,
      "nacelle_radius": 1.13,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0.17,
      "nacelle_undercutStart": 0.05,
      "nacelle_undercut": 0.27,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.15,
      "pylon_nacelleAftOffset": 0.55,
      "pylon_engineeringForeOffset": -0.7,
      "pylon_engineeringAftOffset": 0.35,
      "pylon_engineeringZOffset": 3.42,
      "pylon_midPointOffset": 0.48,
      "pylon_thickness": 0.35,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 21.26,
      "nacelleLower_x": 1.33,
      "nacelleLower_z": -1.86,
      "nacelleLower_length": 6.38,
      "nacelleLower_radius": 0.53,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_undercutStart": 0.15,
      "nacelleLower_undercut": 0.43,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.08,
      "name": "Delta Refit",
      "nacelle_lowerToggle": false,
      "engineering_segments": 17.01,
      "nacelle_segments": 17.01,
      "nacelle_skew": 0,
      "nacelleLower_segments": 17.01,
      "nacelleLower_skew": 0,
      "primary_segments": 34.01,
      "primary_bridgeSegments": 34.01
    },
    {
      "primary_toggle": true,
      "primary_y": -20,
      "primary_z": 0.01,
      "primary_radius": 10.81,
      "primary_thickness": 3.61,
      "primary_widthRatio": 0.45,
      "primary_pointiness": 0.66,
      "primary_bridgeThickness": 0.81,
      "primary_bridgeRadius": 0.19,
      "primary_bridgeWidthRatio": 1.19,
      "primary_bridgeZ": -0.07,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 0,
      "primary_windowsY": 0.24,
      "primary_windowsRepeatY": 3.48,
      "primary_windowsRepeatX": 2,
      "sublight_toggle": true,
      "sublight_y": 23.31,
      "sublight_x": 2.8,
      "sublight_z": -2.48,
      "sublight_length": 3.74,
      "sublight_radius": 0.59,
      "sublight_widthRatio": 6.5,
      "sublight_rotation": -0.2,
      "sublight_segments": 8,
      "sublight_skewVertical": 0,
      "sublight_skewHorizontal": 0.74,
      "neck_toggle": false,
      "neck_primaryForeOffset": 1,
      "neck_primaryAftOffset": -0.09,
      "neck_engineeringForeOffset": 0.53,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.5,
      "neck_thickness": 2.32,
      "neck_foretaper": 0.01,
      "neck_afttaper": 0.24,
      "engineering_toggle": true,
      "engineering_y": -20.85,
      "engineering_z": 4.24,
      "engineering_length": 7.02,
      "engineering_radius": 3.84,
      "engineering_widthRatio": 0.15,
      "engineering_skew": -0.89,
      "engineering_undercut": 0.78,
      "engineering_undercutStart": 0.45,
      "engineering_undercutCurve": 5.71,
      "engineering_dishRadius": 0.93,
      "engineering_dishInset": 0.29,
      "nacelle_toggle": true,
      "nacelle_y": 9.11,
      "nacelle_x": -7.88,
      "nacelle_z": -4.63,
      "nacelle_length": 24.58,
      "nacelle_radius": 2.08,
      "nacelle_widthRatio": 0.41,
      "nacelle_rotation": 0.21,
      "nacelle_segments": 32,
      "nacelle_skew": -0.73,
      "nacelle_undercutStart": 0.23,
      "nacelle_undercut": 0.87,
      "nacelle_bussardWidthRatio": 2.08,
      "nacelle_bussardRadius": 0.66,
      "nacelle_bussardCurvature": 1.29,
      "nacelle_bussardSkewVertical": -0.82,
      "nacelle_bussardYOffset": 0.67,
      "nacelle_bussardZOffset": -0.73,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.71,
      "pylon_nacelleAftOffset": 0.16,
      "pylon_engineeringForeOffset": -0.7,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": -2.5,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.04,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 20.01,
      "nacelleLower_x": 0,
      "nacelleLower_z": -3.34,
      "nacelleLower_length": 40.96,
      "nacelleLower_radius": 4.08,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.22,
      "nacelleLower_undercut": 1,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1.68,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 5,
      "nacelleLower_bussardZOffset": -0.9,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": -0.3,
      "pylonLower_nacelleAftOffset": 0.1,
      "pylonLower_engineeringForeOffset": 0.49,
      "pylonLower_engineeringAftOffset": 0.46,
      "pylonLower_engineeringZOffset": -0.86,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 1.16,
      "name": "Arabica Clipper IV",
      "nacelle_lowerToggle": false,
      "notchAngleAft": null,
      "engineering_segments": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -7.16,
      "primary_z": 1.68,
      "primary_radius": 12,
      "primary_thickness": 4.99,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 0.53,
      "primary_bridgeRadius": 1.2,
      "primary_bridgeWidthRatio": 0.39,
      "primary_bridgeZ": -0.93,
      "primary_bridgeY": 0.75,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.37,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.79,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 1.82,
      "neck_thickness": 0.08,
      "neck_foretaper": 0.32,
      "neck_afttaper": 1.68,
      "engineering_toggle": true,
      "engineering_y": -22.16,
      "engineering_z": 8.62,
      "engineering_length": 10.68,
      "engineering_radius": 1.82,
      "engineering_widthRatio": 1.54,
      "engineering_skew": -0.63,
      "engineering_undercut": 0.44,
      "engineering_undercutStart": 0.29,
      "engineering_undercutCurve": 4.91,
      "engineering_dishRadius": 0.88,
      "engineering_dishInset": 0.33,
      "nacelle_toggle": true,
      "nacelle_y": 20.25,
      "nacelle_x": 3.59,
      "nacelle_z": -1.67,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0.29,
      "nacelle_undercut": 0.71,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.02,
      "pylon_nacelleAftOffset": 0.88,
      "pylon_engineeringForeOffset": 0.97,
      "pylon_engineeringAftOffset": -0.3,
      "pylon_engineeringZOffset": -5.52,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.23,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 8.91,
      "nacelleLower_x": 0,
      "nacelleLower_z": 3.29,
      "nacelleLower_length": 20.8,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.69,
      "pylonLower_nacelleAftOffset": 0.15,
      "pylonLower_engineeringForeOffset": 0.47,
      "pylonLower_engineeringAftOffset": 0.07,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.48,
      "name": "Dust Devil",
      "nacelle_lowerToggle": false,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0
    },
    {
      "primary_toggle": true,
      "primary_y": -4.3,
      "primary_z": -1.49,
      "primary_radius": 5.17,
      "primary_thickness": 6.57,
      "primary_widthRatio": 0.6,
      "primary_pointiness": 0.76,
      "primary_bridgeThickness": 0.95,
      "primary_bridgeRadius": 0.02,
      "primary_bridgeWidthRatio": 1.52,
      "primary_bridgeZ": -0.59,
      "primary_bridgeY": 0.02,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 0.13,
      "neck_thickness": 0.13,
      "neck_foretaper": 0.43,
      "neck_afttaper": 0.43,
      "engineering_toggle": true,
      "engineering_y": -10.03,
      "engineering_z": 2.83,
      "engineering_length": 12.26,
      "engineering_radius": 1.25,
      "engineering_widthRatio": 1.31,
      "engineering_skew": -0.91,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 1.88,
      "nacelle_x": 1.95,
      "nacelle_z": -4.07,
      "nacelle_length": 13.26,
      "nacelle_radius": 0.79,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 0,
      "pylon_engineeringForeOffset": 0.56,
      "pylon_engineeringAftOffset": 0.06,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.58,
      "pylon_thickness": 0.2,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 5.27,
      "nacelleLower_x": 1.18,
      "nacelleLower_z": 0.71,
      "nacelleLower_length": 6.19,
      "nacelleLower_radius": 0.75,
      "nacelleLower_widthRatio": 2.55,
      "nacelleLower_rotation": -0.64,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.34,
      "pylonLower_nacelleAftOffset": 0.48,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.06,
      "name": "Shuttle McShuttleface Class IV",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -11.86,
      "primary_z": 1.3,
      "primary_radius": 13.98,
      "primary_thickness": 3.37,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.28,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 0.4,
      "primary_windowsY": -0.25,
      "primary_windowsRepeatY": 4.99,
      "primary_windowsRepeatX": 6,
      "sublight_toggle": true,
      "sublight_y": 17,
      "sublight_x": 0.99,
      "sublight_z": -2.99,
      "sublight_length": 4.34,
      "sublight_radius": 0.64,
      "sublight_widthRatio": 4.88,
      "sublight_rotation": 0,
      "sublight_segments": 3,
      "sublight_skewVertical": -0.69,
      "sublight_skewHorizontal": -0.03,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.01,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.69,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 2.48,
      "neck_thickness": 0.01,
      "neck_foretaper": 0.6,
      "neck_afttaper": 0.21,
      "engineering_toggle": true,
      "engineering_y": -33.36,
      "engineering_z": -0.66,
      "engineering_length": 16.69,
      "engineering_radius": 1.8,
      "engineering_widthRatio": 2.02,
      "engineering_skew": 0.34,
      "engineering_undercut": 0.6,
      "engineering_undercutStart": 0.29,
      "engineering_undercutCurve": 8.15,
      "engineering_dishRadius": 0.91,
      "engineering_dishInset": 1.15,
      "nacelle_toggle": true,
      "nacelle_y": 0.36,
      "nacelle_x": -6.93,
      "nacelle_z": -7.12,
      "nacelle_length": 17.14,
      "nacelle_radius": 1.75,
      "nacelle_widthRatio": 0.63,
      "nacelle_rotation": 0.53,
      "nacelle_segments": 32,
      "nacelle_skew": -1.41,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.51,
      "nacelle_bussardWidthRatio": 1.47,
      "nacelle_bussardRadius": 0.62,
      "nacelle_bussardCurvature": 1.17,
      "nacelle_bussardSkewVertical": -0.01,
      "nacelle_bussardYOffset": 1.21,
      "nacelle_bussardZOffset": -1.17,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.19,
      "pylon_nacelleAftOffset": 0.31,
      "pylon_engineeringForeOffset": 0.48,
      "pylon_engineeringAftOffset": 0.37,
      "pylon_engineeringZOffset": -0.1,
      "pylon_midPointOffset": 0.2,
      "pylon_thickness": 0.15,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 40,
      "nacelleLower_x": 2.5,
      "nacelleLower_z": -3.5,
      "nacelleLower_length": 12,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.29,
      "nacelleLower_undercut": 0.8,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.15,
      "name": "Sebu III",
      "nacelle_lowerToggle": false,
      "notchAngleAft": null,
      "engineering_segments": 32,
      "primary_segments": 64,
      "primary_bridgeSegments": 64
    },
    {
      "primary_toggle": true,
      "primary_y": -8.54,
      "primary_z": -0.94,
      "primary_radius": 12,
      "primary_thickness": 8.08,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 0.73,
      "primary_bridgeRadius": 0.05,
      "primary_bridgeWidthRatio": 0.74,
      "primary_bridgeZ": -1,
      "primary_bridgeY": 0.29,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.48,
      "neck_primaryAftOffset": 0.03,
      "neck_engineeringForeOffset": 0.15,
      "neck_engineeringAftOffset": 0.59,
      "neck_primaryThickness": 5,
      "neck_thickness": 5,
      "neck_foretaper": 0.26,
      "neck_afttaper": 0.49,
      "engineering_toggle": true,
      "engineering_y": -30.83,
      "engineering_z": 7.81,
      "engineering_length": 21.01,
      "engineering_radius": 4.84,
      "engineering_widthRatio": 1.02,
      "engineering_skew": -0.83,
      "engineering_undercut": 1,
      "engineering_undercutStart": 0.25,
      "engineering_undercutCurve": 3.28,
      "engineering_dishRadius": 0.66,
      "engineering_dishInset": 0.95,
      "nacelle_toggle": true,
      "nacelle_y": 22.62,
      "nacelle_x": 3.4,
      "nacelle_z": -2.17,
      "nacelle_length": 18.42,
      "nacelle_radius": 2.47,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.52,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": -0.01,
      "pylon_nacelleAftOffset": 0.82,
      "pylon_engineeringForeOffset": 0.62,
      "pylon_engineeringAftOffset": 0.23,
      "pylon_engineeringZOffset": -2.12,
      "pylon_midPointOffset": 0.99,
      "pylon_thickness": 0.65,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 17.06,
      "nacelleLower_x": -1.64,
      "nacelleLower_z": 6.19,
      "nacelleLower_length": 8.06,
      "nacelleLower_radius": 3.4,
      "nacelleLower_widthRatio": 0.47,
      "nacelleLower_rotation": -1.56,
      "nacelleLower_undercutStart": 0.29,
      "nacelleLower_undercut": 0.8,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.48,
      "pylonLower_engineeringForeOffset": 0,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.34,
      "pylonLower_thickness": 0.01,
      "name": "plumpcelsior",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -4.06,
      "primary_z": 5.94,
      "primary_radius": 26.14,
      "primary_thickness": 5.34,
      "primary_widthRatio": 0.77,
      "primary_pointiness": 0.36,
      "primary_bridgeThickness": 1.1,
      "primary_bridgeRadius": 1.2,
      "primary_bridgeWidthRatio": 0.47,
      "primary_bridgeZ": 0.74,
      "primary_bridgeY": 0.06,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 0.77,
      "primary_windowsY": 0,
      "primary_windowsRepeatY": 2,
      "primary_windowsRepeatX": 4,
      "sublight_toggle": true,
      "sublight_y": 2.51,
      "sublight_x": 3.49,
      "sublight_z": -8.28,
      "sublight_length": 12.82,
      "sublight_radius": 0.9,
      "sublight_widthRatio": 3.83,
      "sublight_rotation": -3.14,
      "sublight_segments": 3,
      "sublight_skewVertical": 1.25,
      "sublight_skewHorizontal": 1.15,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.88,
      "neck_primaryAftOffset": -0.3,
      "neck_engineeringForeOffset": 0.82,
      "neck_engineeringAftOffset": 0.59,
      "neck_primaryThickness": 1.93,
      "neck_thickness": 0.01,
      "neck_foretaper": 2.78,
      "neck_afttaper": 0.68,
      "engineering_toggle": true,
      "engineering_y": -39.78,
      "engineering_z": 10.72,
      "engineering_length": 27.11,
      "engineering_radius": 4.78,
      "engineering_widthRatio": 0.56,
      "engineering_skew": -1.82,
      "engineering_undercut": 1,
      "engineering_undercutStart": 0.29,
      "engineering_undercutCurve": 2.21,
      "engineering_dishRadius": 0.91,
      "engineering_dishInset": 2,
      "nacelle_toggle": true,
      "nacelle_y": 22.88,
      "nacelle_x": 7.18,
      "nacelle_z": -6.87,
      "nacelle_length": 26.07,
      "nacelle_radius": 2.09,
      "nacelle_widthRatio": 0.31,
      "nacelle_rotation": -2.33,
      "nacelle_segments": 32,
      "nacelle_skew": 0,
      "nacelle_undercutStart": 0.12,
      "nacelle_undercut": 0.6,
      "nacelle_bussardWidthRatio": 1,
      "nacelle_bussardRadius": 1,
      "nacelle_bussardCurvature": 1.51,
      "nacelle_bussardSkewVertical": -2.75,
      "nacelle_bussardYOffset": 0.84,
      "nacelle_bussardZOffset": -0.63,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.05,
      "pylon_nacelleAftOffset": 0.48,
      "pylon_engineeringForeOffset": 0.5,
      "pylon_engineeringAftOffset": 0.3,
      "pylon_engineeringZOffset": -0.31,
      "pylon_midPointOffset": 0.45,
      "pylon_thickness": 0.21,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 22.8,
      "nacelleLower_x": 7.17,
      "nacelleLower_z": 10.69,
      "nacelleLower_length": 25.62,
      "nacelleLower_radius": 2.29,
      "nacelleLower_widthRatio": 0.25,
      "nacelleLower_rotation": -0.79,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.29,
      "nacelleLower_undercut": 0.8,
      "nacelleLower_bussardWidthRatio": 0.93,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1.37,
      "nacelleLower_bussardSkewVertical": -2.35,
      "nacelleLower_bussardYOffset": 1.44,
      "nacelleLower_bussardZOffset": -0.56,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.48,
      "pylonLower_engineeringForeOffset": 0.52,
      "pylonLower_engineeringAftOffset": 0.34,
      "pylonLower_engineeringZOffset": -1.83,
      "pylonLower_midPointOffset": 0.45,
      "pylonLower_thickness": 0.19,
      "name": "USS Braids of Gertrude VIII",
      "nacelle_lowerToggle": false,
      "notchAngleAft": null,
      "engineering_segments": 32,
      "primary_segments": 3,
      "primary_bridgeSegments": 3
    },
    {
      "primary_toggle": true,
      "primary_y": -3.07,
      "primary_z": 4.44,
      "primary_radius": 4.53,
      "primary_thickness": 7.5,
      "primary_widthRatio": 0.48,
      "primary_pointiness": 0.36,
      "primary_bridgeThickness": 0.61,
      "primary_bridgeRadius": 0.59,
      "primary_bridgeWidthRatio": 0.72,
      "primary_bridgeZ": -0.23,
      "primary_bridgeY": 0.14,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.54,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0,
      "neck_engineeringAftOffset": 0.2,
      "neck_primaryThickness": 1.47,
      "neck_thickness": 0.01,
      "neck_foretaper": 0.27,
      "neck_afttaper": 0.29,
      "engineering_toggle": true,
      "engineering_y": -24.18,
      "engineering_z": 5.52,
      "engineering_length": 16.63,
      "engineering_radius": 0.68,
      "engineering_widthRatio": 1.84,
      "engineering_skew": -1.45,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 14.16,
      "nacelle_x": 3.41,
      "nacelle_z": -7.94,
      "nacelle_length": 17.24,
      "nacelle_radius": 1.2,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.12,
      "pylon_nacelleAftOffset": 1,
      "pylon_engineeringForeOffset": 0.82,
      "pylon_engineeringAftOffset": 0.29,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.27,
      "pylon_thickness": 0.22,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 21.08,
      "nacelleLower_x": -0.64,
      "nacelleLower_z": 5.9,
      "nacelleLower_length": 6.53,
      "nacelleLower_radius": 1.11,
      "nacelleLower_widthRatio": 1.48,
      "nacelleLower_rotation": 0.02,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.46,
      "pylonLower_engineeringForeOffset": 0,
      "pylonLower_engineeringAftOffset": 0.63,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.04,
      "name": "Magic Carpet Mk I",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -1.76,
      "primary_z": 3.96,
      "primary_radius": 18.57,
      "primary_thickness": 4.33,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 0.9,
      "primary_bridgeRadius": 0.1,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": -0.15,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0.18,
      "primary_notchAngleAft": 0.67,
      "sublight_toggle": true,
      "sublight_y": 16.14,
      "sublight_x": 1.67,
      "sublight_z": -6.28,
      "sublight_length": 3.59,
      "sublight_radius": 0.53,
      "sublight_widthRatio": 7.33,
      "sublight_rotation": -0.03,
      "sublight_segments": 3,
      "sublight_skewVertical": -1.04,
      "sublight_skewHorizontal": 1.02,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.47,
      "neck_primaryAftOffset": -0.05,
      "neck_engineeringForeOffset": 0.28,
      "neck_engineeringAftOffset": 0.82,
      "neck_primaryThickness": 0.91,
      "neck_thickness": 4.14,
      "neck_foretaper": 1.07,
      "neck_afttaper": 0.66,
      "engineering_toggle": true,
      "engineering_y": -19.47,
      "engineering_z": 7.3,
      "engineering_length": 10.89,
      "engineering_radius": 2.29,
      "engineering_widthRatio": 0.75,
      "engineering_skew": -0.56,
      "engineering_undercut": 0.89,
      "engineering_undercutStart": 0.32,
      "engineering_undercutCurve": 2.42,
      "engineering_dishRadius": 0.97,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 19.15,
      "nacelle_x": 6.33,
      "nacelle_z": -5.06,
      "nacelle_length": 19.52,
      "nacelle_radius": 1.65,
      "nacelle_widthRatio": 0.34,
      "nacelle_rotation": -1.46,
      "nacelle_skew": -0.82,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.74,
      "nacelle_bussardWidthRatio": 1.98,
      "nacelle_bussardRadius": 0.58,
      "nacelle_bussardCurvature": 1.39,
      "nacelle_bussardSkewVertical": 1.48,
      "nacelle_bussardYOffset": 3.17,
      "nacelle_bussardZOffset": -0.93,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.62,
      "pylon_engineeringForeOffset": 0.06,
      "pylon_engineeringAftOffset": 0.64,
      "pylon_engineeringZOffset": -1.2,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.21,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 30,
      "nacelleLower_x": 8.4,
      "nacelleLower_z": 4.31,
      "nacelleLower_length": 12.02,
      "nacelleLower_radius": 1.03,
      "nacelleLower_widthRatio": 0.99,
      "nacelleLower_rotation": -0.01,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 0.99,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.57,
      "pylonLower_engineeringForeOffset": 0.56,
      "pylonLower_engineeringAftOffset": 0.17,
      "pylonLower_engineeringZOffset": -0.13,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.15,
      "name": "USS Caitian Paw V",
      "nacelle_lowerToggle": false,
      "notchAngleAft": null,
      "engineering_segments": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -1.76,
      "primary_z": 3.96,
      "primary_radius": 18.57,
      "primary_thickness": 4.33,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 0.9,
      "primary_bridgeRadius": 0.1,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": -0.15,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 1,
      "sublight_toggle": true,
      "sublight_y": 19.01,
      "sublight_x": 1.16,
      "sublight_z": -6.01,
      "sublight_length": 3.59,
      "sublight_radius": 0.53,
      "sublight_widthRatio": 7.33,
      "sublight_rotation": -0.03,
      "sublight_segments": 3,
      "sublight_skewVertical": -1.04,
      "sublight_skewHorizontal": 1.02,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.47,
      "neck_primaryAftOffset": -0.21,
      "neck_engineeringForeOffset": 0.28,
      "neck_engineeringAftOffset": 0.82,
      "neck_primaryThickness": 0.91,
      "neck_thickness": 4.14,
      "neck_foretaper": 1.07,
      "neck_afttaper": 0.66,
      "engineering_toggle": true,
      "engineering_y": -19.47,
      "engineering_z": 7.3,
      "engineering_length": 10.89,
      "engineering_radius": 2.29,
      "engineering_widthRatio": 0.75,
      "engineering_skew": -0.56,
      "engineering_undercut": 0.89,
      "engineering_undercutStart": 0.32,
      "engineering_undercutCurve": 2.42,
      "engineering_dishRadius": 0.97,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 21.16,
      "nacelle_x": 3.83,
      "nacelle_z": -5.06,
      "nacelle_length": 19.52,
      "nacelle_radius": 1.65,
      "nacelle_widthRatio": 0.34,
      "nacelle_rotation": -1.46,
      "nacelle_skew": -0.82,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.74,
      "nacelle_bussardWidthRatio": 1.98,
      "nacelle_bussardRadius": 0.58,
      "nacelle_bussardCurvature": 1.39,
      "nacelle_bussardSkewVertical": 1.48,
      "nacelle_bussardYOffset": 3.17,
      "nacelle_bussardZOffset": -0.93,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.56,
      "pylon_engineeringForeOffset": 0.06,
      "pylon_engineeringAftOffset": 0.64,
      "pylon_engineeringZOffset": -1.2,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.21,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 30,
      "nacelleLower_x": 4.95,
      "nacelleLower_z": 4.31,
      "nacelleLower_length": 12.02,
      "nacelleLower_radius": 1.03,
      "nacelleLower_widthRatio": 0.99,
      "nacelleLower_rotation": -0.01,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 0.99,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.53,
      "pylonLower_engineeringForeOffset": 0.39,
      "pylonLower_engineeringAftOffset": 0.17,
      "pylonLower_engineeringZOffset": -0.13,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.15,
      "name": "Caitian Paw V warp mode",
      "notchAngleAft": null,
      "nacelle_lowerToggle": false,
      "primary_segments": 64,
      "primary_bridgeSegments": 64
    },
    {
      "primary_toggle": true,
      "primary_y": -3.94,
      "primary_z": -2.74,
      "primary_radius": 19.36,
      "primary_thickness": 9.16,
      "primary_widthRatio": 1.02,
      "primary_pointiness": 0.3,
      "primary_bridgeThickness": 0.87,
      "primary_bridgeRadius": 0.65,
      "primary_bridgeWidthRatio": 0.62,
      "primary_bridgeZ": -0.56,
      "primary_bridgeY": -0.09,
      "primary_notchAngle": 0.32,
      "primary_notchAngleAft": 0.55,
      "primary_windowsY": 0,
      "primary_windowsRepeatY": 2,
      "primary_windowsRepeatX": 4,
      "sublight_toggle": true,
      "sublight_y": 22.74,
      "sublight_x": 7.53,
      "sublight_z": -1.78,
      "sublight_length": 4.04,
      "sublight_radius": 1.71,
      "sublight_widthRatio": 2.28,
      "sublight_rotation": -0.47,
      "sublight_segments": 6,
      "sublight_skewVertical": 0,
      "sublight_skewHorizontal": 0.8,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.74,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 2.96,
      "neck_thickness": 0.01,
      "neck_foretaper": 0.71,
      "neck_afttaper": 0.59,
      "engineering_toggle": true,
      "engineering_y": -13.04,
      "engineering_z": 1.9,
      "engineering_length": 25.03,
      "engineering_radius": 1.41,
      "engineering_widthRatio": 4.22,
      "engineering_skew": 0.31,
      "engineering_undercut": 0.78,
      "engineering_undercutStart": 0.45,
      "engineering_undercutCurve": 1,
      "engineering_dishRadius": 1.1,
      "engineering_dishInset": 0.6,
      "nacelle_toggle": true,
      "nacelle_y": 4.66,
      "nacelle_x": 7.36,
      "nacelle_z": -1.85,
      "nacelle_length": 19.67,
      "nacelle_radius": 2.65,
      "nacelle_widthRatio": 0.98,
      "nacelle_rotation": 0.92,
      "nacelle_segments": 32,
      "nacelle_skew": -0.62,
      "nacelle_undercutStart": 0.84,
      "nacelle_undercut": 1,
      "nacelle_bussardWidthRatio": 1,
      "nacelle_bussardRadius": 1.03,
      "nacelle_bussardCurvature": 0.96,
      "nacelle_bussardSkewVertical": -0.01,
      "nacelle_bussardYOffset": 1.28,
      "nacelle_bussardZOffset": -0.66,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.29,
      "pylon_nacelleAftOffset": 0.2,
      "pylon_engineeringForeOffset": 1.24,
      "pylon_engineeringAftOffset": -0.49,
      "pylon_engineeringZOffset": -4.87,
      "pylon_midPointOffset": 0.49,
      "pylon_thickness": 0.24,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 16.85,
      "nacelleLower_x": -7.11,
      "nacelleLower_z": 1.38,
      "nacelleLower_length": 15.06,
      "nacelleLower_radius": 5.3,
      "nacelleLower_widthRatio": 0.15,
      "nacelleLower_rotation": -1.09,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.42,
      "nacelleLower_undercut": 1,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": -0.15,
      "pylonLower_nacelleAftOffset": 0.63,
      "pylonLower_engineeringForeOffset": 1.3,
      "pylonLower_engineeringAftOffset": -0.48,
      "pylonLower_engineeringZOffset": -6,
      "pylonLower_midPointOffset": 0.45,
      "pylonLower_thickness": 0.16,
      "name": "USS Hint of Lilac VII",
      "nacelle_lowerToggle": false,
      "notchAngleAft": null,
      "engineering_segments": 32,
      "primary_segments": 64,
      "primary_bridgeSegments": 64
    },
    {
      "primary_toggle": true,
      "primary_y": 1.77,
      "primary_z": -2.47,
      "primary_radius": 12.77,
      "primary_thickness": 4.57,
      "primary_widthRatio": 0.6,
      "primary_pointiness": 0.31,
      "primary_bridgeThickness": 0.89,
      "primary_bridgeRadius": 0.29,
      "primary_bridgeWidthRatio": 0.75,
      "primary_bridgeZ": -0.18,
      "primary_bridgeY": -0.06,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.01,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 3.03,
      "neck_thickness": 3.39,
      "neck_foretaper": 0.29,
      "neck_afttaper": 0.01,
      "engineering_toggle": true,
      "engineering_y": -18.28,
      "engineering_z": 2.53,
      "engineering_length": 17.59,
      "engineering_radius": 1.67,
      "engineering_widthRatio": 0.95,
      "engineering_skew": -2.2,
      "engineering_undercut": 0.74,
      "engineering_undercutStart": 0.22,
      "engineering_undercutCurve": 5.24,
      "engineering_dishRadius": 0.68,
      "engineering_dishInset": 0.98,
      "nacelle_toggle": false,
      "nacelle_y": 18.2,
      "nacelle_x": 0,
      "nacelle_z": -11.85,
      "nacelle_length": 5.82,
      "nacelle_radius": 0.44,
      "nacelle_widthRatio": 1.12,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0.82,
      "nacelle_undercut": 1,
      "pylon_toggle": false,
      "pylon_nacelleForeOffset": 0.25,
      "pylon_nacelleAftOffset": 0.2,
      "pylon_engineeringForeOffset": 0.26,
      "pylon_engineeringAftOffset": 0.1,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.12,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 15.83,
      "nacelleLower_x": 3.24,
      "nacelleLower_z": -0.01,
      "nacelleLower_length": 20.55,
      "nacelleLower_radius": 1.39,
      "nacelleLower_widthRatio": 0.41,
      "nacelleLower_rotation": -0.18,
      "nacelleLower_undercutStart": 0.11,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.21,
      "pylonLower_nacelleAftOffset": 0.68,
      "pylonLower_engineeringForeOffset": 0.25,
      "pylonLower_engineeringAftOffset": 0.26,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.19,
      "pylonLower_thickness": 0.1,
      "name": "Persephone's Want",
      "nacelle_lowerToggle": false,
      "primary_segments": 3,
      "primary_bridgeSegments": 3,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0
    },
    {
      "primary_toggle": true,
      "primary_y": -20,
      "primary_z": 1.81,
      "primary_radius": 7.55,
      "primary_thickness": 4.98,
      "primary_widthRatio": 0.54,
      "primary_pointiness": 0.61,
      "primary_bridgeThickness": 0.5,
      "primary_bridgeRadius": 0.7,
      "primary_bridgeWidthRatio": 0.66,
      "primary_bridgeZ": -1,
      "primary_bridgeY": -0.29,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.07,
      "neck_primaryAftOffset": 0.03,
      "neck_engineeringForeOffset": 0.17,
      "neck_engineeringAftOffset": 0.7,
      "neck_primaryThickness": 1.57,
      "neck_thickness": 0.95,
      "neck_foretaper": 0.27,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -12.47,
      "engineering_z": 7.59,
      "engineering_length": 15.3,
      "engineering_radius": 2.41,
      "engineering_widthRatio": 1,
      "engineering_skew": -0.53,
      "engineering_undercut": 1,
      "engineering_undercutStart": 0.29,
      "engineering_undercutCurve": 6.64,
      "engineering_dishRadius": 0.93,
      "engineering_dishInset": 0.88,
      "nacelle_toggle": true,
      "nacelle_y": -10.83,
      "nacelle_x": 4.78,
      "nacelle_z": -7.9,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.58,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.76,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.45,
      "pylon_engineeringForeOffset": 0.56,
      "pylon_engineeringAftOffset": 0.19,
      "pylon_engineeringZOffset": -0.52,
      "pylon_midPointOffset": 0.58,
      "pylon_thickness": 0.18,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 16.85,
      "nacelleLower_x": 1.76,
      "nacelleLower_z": 4.13,
      "nacelleLower_length": 12,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_undercutStart": 0.29,
      "nacelleLower_undercut": 0.8,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": -0.3,
      "pylonLower_nacelleAftOffset": 0.4,
      "pylonLower_engineeringForeOffset": 0.26,
      "pylonLower_engineeringAftOffset": 0.58,
      "pylonLower_engineeringZOffset": -0.35,
      "pylonLower_midPointOffset": 2,
      "pylonLower_thickness": 0.15,
      "name": "SoCal Dilithium Burndown",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -3.83,
      "primary_z": 1.64,
      "primary_radius": 7.99,
      "primary_thickness": 6.23,
      "primary_widthRatio": 1.01,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 2.14,
      "primary_bridgeRadius": 0.73,
      "primary_bridgeWidthRatio": 0.96,
      "primary_bridgeZ": 2.06,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0.32,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.74,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 5,
      "neck_thickness": 0.01,
      "neck_foretaper": 1.21,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -28.42,
      "engineering_z": 5.52,
      "engineering_length": 32.17,
      "engineering_radius": 2.62,
      "engineering_widthRatio": 1,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.45,
      "engineering_undercutCurve": 3.23,
      "engineering_dishRadius": 1.1,
      "engineering_dishInset": 0.13,
      "nacelle_toggle": true,
      "nacelle_y": 15,
      "nacelle_x": 4.95,
      "nacelle_z": 1.04,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": -0.99,
      "nacelle_undercutStart": 0.26,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 0.8,
      "pylon_engineeringForeOffset": 0.8,
      "pylon_engineeringAftOffset": 0.1,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 13.99,
      "nacelleLower_x": 0,
      "nacelleLower_z": 15,
      "nacelleLower_length": 23.09,
      "nacelleLower_radius": 1.4,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 3.14,
      "nacelleLower_undercutStart": 0.22,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.8,
      "pylonLower_engineeringForeOffset": 0.8,
      "pylonLower_engineeringAftOffset": 0.1,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.45,
      "name": "Bewilderment's Stare",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {  
      "primary_toggle": true,
       "primary_y": -6.35,
       "primary_z": 2.09,
       "primary_radius": 25.52,
       "primary_thickness": 6.45,
       "primary_widthRatio": 0.61,
       "primary_pointiness": 0.41,
       "primary_bridgeThickness": 1.02,
       "primary_bridgeRadius": 0.63,
       "primary_bridgeWidthRatio": 0.8,
       "primary_bridgeZ": 0.5,
       "primary_bridgeY": 0.05,
       "primary_notchAngle": 0,
       "primary_notchAngleAft": 0.81,
       "sublight_toggle": true,
       "sublight_y": 15.6,
       "sublight_x": 1.58,
       "sublight_z": -4.33,
       "sublight_length": 3.82,
       "sublight_radius": 0.51,
       "sublight_widthRatio": 8.35,
       "sublight_rotation": 0,
       "sublight_segments": 3,
       "sublight_skewVertical": -1.1,
       "sublight_skewHorizontal": 0.79,
       "neck_toggle": true,
       "neck_primaryForeOffset": 0.14,
       "neck_primaryAftOffset": 0.03,
       "neck_engineeringForeOffset": 1,
       "neck_engineeringAftOffset": 0,
       "neck_primaryThickness": 4.01,
       "neck_thickness": 0.01,
       "neck_foretaper": 0.01,
       "neck_afttaper": 0.6,
       "engineering_toggle": true,
       "engineering_y": -34.39,
       "engineering_z": 12.83,
       "engineering_length": 21.74,
       "engineering_radius": 3.2,
       "engineering_widthRatio": 0.69,
       "engineering_skew": -1.55,
       "engineering_undercut": 0.5,
       "engineering_undercutStart": 0.09,
       "engineering_undercutCurve": 6.64,
       "engineering_dishRadius": 0.85,
       "engineering_dishInset": 0.69,
       "nacelle_toggle": true,
       "nacelle_y": 19.72,
       "nacelle_x": 6.67,
       "nacelle_z": -9.1,
       "nacelle_length": 28.75,
       "nacelle_radius": 1.83,
       "nacelle_widthRatio": 1,
       "nacelle_rotation": 0,

       "nacelle_skew": -0.24,
       "nacelle_undercutStart": 0,
       "nacelle_undercut": 0.51,
       "nacelle_bussardWidthRatio": 1,
       "nacelle_bussardRadius": 1.08,
       "nacelle_bussardCurvature": 1.5,
       "nacelle_bussardSkewVertical": -0.67,
       "nacelle_bussardYOffset": 0,
       "nacelle_bussardZOffset": -0.63,
       "pylon_toggle": true,
       "pylon_nacelleForeOffset": 0.02,
       "pylon_nacelleAftOffset": 0.81,
       "pylon_engineeringForeOffset": 0.56,
       "pylon_engineeringAftOffset": 0.08,
       "pylon_engineeringZOffset": -0.6,
       "pylon_midPointOffset": 0.3,
       "pylon_thickness": 0.08,
       "nacelleLower_toggle": true,
       "nacelleLower_y": 24.6,
       "nacelleLower_x": 6.66,
       "nacelleLower_z": 9.07,
       "nacelleLower_length": 12.23,
       "nacelleLower_radius": 2.29,
       "nacelleLower_widthRatio": 0.35,
       "nacelleLower_rotation": 0,
       "nacelleLower_segments": 32,
       "nacelleLower_skew": 0,
       "nacelleLower_undercutStart": 0.29,
       "nacelleLower_undercut": 0.8,
       "nacelleLower_bussardWidthRatio": 1,
       "nacelleLower_bussardRadius": 1,
       "nacelleLower_bussardCurvature": 1,
       "nacelleLower_bussardSkewVertical": 0,
       "nacelleLower_bussardYOffset": 0,
       "nacelleLower_bussardZOffset": 0,
       "boomLower_toggle": true,
       "pylonLower_toggle": true,
       "pylonLower_nacelleForeOffset": 0.14,
       "pylonLower_nacelleAftOffset": 0.4,
       "pylonLower_engineeringForeOffset": 0.05,
       "pylonLower_engineeringAftOffset": 0.54,
       "pylonLower_engineeringZOffset": -6,
       "pylonLower_midPointOffset": 0.32,
       "pylonLower_thickness": 0.13,
       "name": "Laura Ingalls V",
       "nacelle_lowerToggle": false,
       "primary_segments": null,
       "primary_bridgeSegments": null,
       "engineering_segments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -1.63,
      "primary_z": 1.22,
      "primary_radius": 12,
      "primary_thickness": 4.12,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.02,
      "primary_bridgeRadius": 1.13,
      "primary_bridgeWidthRatio": 0.41,
      "primary_bridgeZ": 0.26,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0.38,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.24,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.66,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 1.82,
      "neck_thickness": 0.08,
      "neck_foretaper": 0.32,
      "neck_afttaper": 1.68,
      "engineering_toggle": true,
      "engineering_y": -21.51,
      "engineering_z": 7.09,
      "engineering_length": 16.13,
      "engineering_radius": 2.63,
      "engineering_widthRatio": 1.01,
      "engineering_skew": -0.52,
      "engineering_undercut": 0.82,
      "engineering_undercutStart": 0.29,
      "engineering_undercutCurve": 4.43,
      "engineering_dishRadius": 0.88,
      "engineering_dishInset": 0.9,
      "nacelle_toggle": true,
      "nacelle_y": 12.15,
      "nacelle_x": 5.83,
      "nacelle_z": 0.37,
      "nacelle_length": 18.06,
      "nacelle_radius": 1.47,
      "nacelle_widthRatio": 0.98,
      "nacelle_rotation": 0.18,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.77,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.2,
      "pylon_nacelleAftOffset": 0.73,
      "pylon_engineeringForeOffset": -0.12,
      "pylon_engineeringAftOffset": 0.56,
      "pylon_engineeringZOffset": -3.97,
      "pylon_midPointOffset": 0.22,
      "pylon_thickness": 0.15,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 40,
      "nacelleLower_x": 2.5,
      "nacelleLower_z": -3.5,
      "nacelleLower_length": 12,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.15,
      "name": "Caliper",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -7.85,
      "primary_z": 1.04,
      "primary_radius": 10.02,
      "primary_thickness": 4.04,
      "primary_widthRatio": 0.16,
      "primary_pointiness": 0.78,
      "primary_bridgeThickness": 0.5,
      "primary_bridgeRadius": 0.17,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": -0.05,
      "primary_bridgeY": 0.03,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 0,
      "sublight_toggle": true,
      "sublight_y": 14.42,
      "sublight_x": 0.98,
      "sublight_z": -3.6,
      "sublight_length": 2.7,
      "sublight_radius": 0.48,
      "sublight_widthRatio": 4.79,
      "sublight_rotation": -0.26,
      "sublight_segments": 3,
      "sublight_skewVertical": 1.98,
      "sublight_skewHorizontal": 0.05,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.75,
      "neck_primaryAftOffset": -0.17,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.56,
      "neck_primaryThickness": 1.32,
      "neck_thickness": 3.86,
      "neck_foretaper": 0.97,
      "neck_afttaper": 1.07,
      "engineering_toggle": true,
      "engineering_y": -22.11,
      "engineering_z": 3.72,
      "engineering_length": 14.01,
      "engineering_radius": 1.77,
      "engineering_widthRatio": 0.56,
      "engineering_skew": -0.38,
      "engineering_undercut": 0.89,
      "engineering_undercutStart": 0.32,
      "engineering_undercutCurve": 2.42,
      "engineering_dishRadius": 0.97,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 22.45,
      "nacelle_x": 6.33,
      "nacelle_z": -5.06,
      "nacelle_length": 7.61,
      "nacelle_radius": 1.65,
      "nacelle_widthRatio": 0.38,
      "nacelle_rotation": 0.02,
      "nacelle_skew": -0.82,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.74,
      "nacelle_bussardWidthRatio": 2.04,
      "nacelle_bussardRadius": 0.69,
      "nacelle_bussardCurvature": 0.65,
      "nacelle_bussardSkewVertical": -0.71,
      "nacelle_bussardYOffset": 0.91,
      "nacelle_bussardZOffset": -0.49,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.62,
      "pylon_engineeringForeOffset": 0.06,
      "pylon_engineeringAftOffset": 0.64,
      "pylon_engineeringZOffset": -0.35,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.21,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 23.45,
      "nacelleLower_x": 8.4,
      "nacelleLower_z": 5.42,
      "nacelleLower_length": 12.02,
      "nacelleLower_radius": 1.03,
      "nacelleLower_widthRatio": 0.99,
      "nacelleLower_rotation": -0.01,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 0.99,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.61,
      "pylonLower_engineeringForeOffset": 0.09,
      "pylonLower_engineeringAftOffset": 0.59,
      "pylonLower_engineeringZOffset": -0.31,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.15,
      "name": "Vasa, Her Wings Wide I",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "notchAngleAft": null
    },
    {
      "primary_toggle": true,
      "primary_y": -1.24,
      "primary_z": 4.37,
      "primary_radius": 29.8,
      "primary_thickness": 9.92,
      "primary_widthRatio": 0.62,
      "primary_pointiness": 0.36,
      "primary_bridgeThickness": 0.94,
      "primary_bridgeRadius": 0.23,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.18,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.21,
      "neck_primaryAftOffset": 0.32,
      "neck_engineeringForeOffset": 0.46,
      "neck_engineeringAftOffset": 0.18,
      "neck_primaryThickness": 1.66,
      "neck_thickness": 3.27,
      "neck_foretaper": 0.1,
      "neck_afttaper": 0.59,
      "engineering_toggle": true,
      "engineering_y": -26.55,
      "engineering_z": 1.61,
      "engineering_length": 22.49,
      "engineering_radius": 2.53,
      "engineering_widthRatio": 1.35,
      "engineering_skew": -0.65,
      "engineering_undercut": 0,
      "engineering_undercutStart": 0,
      "engineering_undercutCurve": 1.04,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0.81,
      "nacelle_toggle": true,
      "nacelle_y": 20.89,
      "nacelle_x": -0.02,
      "nacelle_z": -14.76,
      "nacelle_length": 46.05,
      "nacelle_radius": 2.71,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0.26,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.16,
      "pylon_nacelleAftOffset": 0.24,
      "pylon_engineeringForeOffset": 0.33,
      "pylon_engineeringAftOffset": 0.18,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 19.35,
      "nacelleLower_x": -0.02,
      "nacelleLower_z": 1.42,
      "nacelleLower_length": 14.58,
      "nacelleLower_radius": 3.67,
      "nacelleLower_widthRatio": 0.52,
      "nacelleLower_rotation": 0,
      "nacelleLower_undercutStart": 0.04,
      "nacelleLower_undercut": 0.73,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.52,
      "pylonLower_nacelleAftOffset": 0.47,
      "pylonLower_engineeringForeOffset": 0.55,
      "pylonLower_engineeringAftOffset": 0.36,
      "pylonLower_engineeringZOffset": -0.56,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.45,
      "name": "Shran's Muse IV",
      "nacelle_lowerToggle": false,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "primary_toggle": true,
      "primary_y": -6.32,
      "primary_z": -1.01,
      "primary_radius": 23.76,
      "primary_thickness": 4.68,
      "primary_widthRatio": 0.76,
      "primary_pointiness": 0.19,
      "primary_bridgeThickness": 1.3,
      "primary_bridgeRadius": 0.66,
      "primary_bridgeWidthRatio": 0.81,
      "primary_bridgeZ": 0.6,
      "primary_bridgeY": 0.17,
      "primary_notchAngle": 0.17,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.3,
      "neck_thickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -21.38,
      "engineering_z": 0.96,
      "engineering_length": 24.3,
      "engineering_radius": 3.69,
      "engineering_widthRatio": 0.5,
      "engineering_skew": -0.05,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.12,
      "engineering_undercutCurve": 6.93,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0.52,
      "nacelle_toggle": true,
      "nacelle_y": 19.13,
      "nacelle_x": 3.53,
      "nacelle_z": -6.19,
      "nacelle_length": 27.92,
      "nacelle_radius": 1.56,
      "nacelle_widthRatio": 0.99,
      "nacelle_rotation": -0.51,
      "nacelle_undercutStart": 0.23,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.19,
      "pylon_nacelleAftOffset": 0.5,
      "pylon_engineeringForeOffset": 0.44,
      "pylon_engineeringAftOffset": -0.05,
      "pylon_engineeringZOffset": 0.05,
      "pylon_midPointOffset": 2,
      "pylon_thickness": 0.27,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 19.13,
      "nacelleLower_x": 3.53,
      "nacelleLower_z": -4.71,
      "nacelleLower_length": 28.75,
      "nacelleLower_radius": 1.56,
      "nacelleLower_widthRatio": 1.06,
      "nacelleLower_rotation": -2.75,
      "nacelleLower_undercutStart": 0.26,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.2,
      "pylonLower_nacelleAftOffset": 0.49,
      "pylonLower_engineeringForeOffset": 0.45,
      "pylonLower_engineeringAftOffset": -0.05,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 2,
      "pylonLower_thickness": 0.27,
      "name": "NorthByNorthSouth",
      "nacelle_lowerToggle": false,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "primary_toggle": true,
      "primary_y": -8.78,
      "primary_z": -1.66,
      "primary_radius": 5.31,
      "primary_thickness": 5.81,
      "primary_widthRatio": 1.32,
      "primary_pointiness": 0,
      "primary_segments": 64,
      "primary_bridgeThickness": 0.77,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.62,
      "primary_bridgeY": 0,
      "primary_bridgeSegments": 64,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.07,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.22,
      "neck_primaryThickness": 1.58,
      "neck_thickness": 1.58,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -18.28,
      "engineering_z": 2.77,
      "engineering_length": 12.24,
      "engineering_radius": 3.82,
      "engineering_widthRatio": 0.95,
      "engineering_skew": -0.11,
      "engineering_undercut": 0.26,
      "engineering_undercutStart": 0.48,
      "engineering_dishRadius": 0.86,
      "engineering_dishInset": 1.35,
      "nacelle_toggle": true,
      "nacelle_y": 18.2,
      "nacelle_x": 2.69,
      "nacelle_z": 1.97,
      "nacelle_length": 10.05,
      "nacelle_radius": 1.85,
      "nacelle_widthRatio": 1.12,
      "nacelle_rotation": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.25,
      "pylon_nacelleAftOffset": 0.2,
      "pylon_engineeringForeOffset": 0.26,
      "pylon_engineeringAftOffset": 0.1,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.12,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 15.83,
      "nacelleLower_x": 3.24,
      "nacelleLower_z": -0.01,
      "nacelleLower_length": 20.55,
      "nacelleLower_radius": 1.39,
      "nacelleLower_widthRatio": 0.58,
      "nacelleLower_rotation": 0.91,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.21,
      "pylonLower_nacelleAftOffset": 0.68,
      "pylonLower_engineeringForeOffset": 0.25,
      "pylonLower_engineeringAftOffset": 0.26,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.25,
      "name": "ISS Hallmark Collectible",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "primary_toggle": true,
      "primary_y": 5.56,
      "primary_z": -4.05,
      "primary_radius": 13.11,
      "primary_thickness": 8.87,
      "primary_widthRatio": 0.42,
      "primary_pointiness": 0.45,
      "primary_segments": 64,
      "primary_bridgeThickness": 0.93,
      "primary_bridgeRadius": 0.49,
      "primary_bridgeWidthRatio": 1.2,
      "primary_bridgeZ": -0.54,
      "primary_bridgeY": -0.06,
      "primary_bridgeSegments": 64,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.07,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.22,
      "neck_primaryThickness": 1.58,
      "neck_thickness": 1.58,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -18.28,
      "engineering_z": 2.53,
      "engineering_length": 37.27,
      "engineering_radius": 4.18,
      "engineering_widthRatio": 0.42,
      "engineering_skew": -1.27,
      "engineering_undercut": 0.58,
      "engineering_undercutStart": 0.19,
      "engineering_dishRadius": 0.83,
      "engineering_dishInset": 2,
      "nacelle_toggle": true,
      "nacelle_y": 0.87,
      "nacelle_x": 1.93,
      "nacelle_z": -3.76,
      "nacelle_length": 23.66,
      "nacelle_radius": 1.64,
      "nacelle_widthRatio": 1.12,
      "nacelle_rotation": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.11,
      "pylon_engineeringForeOffset": 0.68,
      "pylon_engineeringAftOffset": 0.11,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.79,
      "pylon_thickness": 0.35,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 9.03,
      "nacelleLower_x": 1.91,
      "nacelleLower_z": 3.84,
      "nacelleLower_length": 16.79,
      "nacelleLower_radius": 2.27,
      "nacelleLower_widthRatio": 0.15,
      "nacelleLower_rotation": 0,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.21,
      "pylonLower_nacelleAftOffset": 0.68,
      "pylonLower_engineeringForeOffset": 0.25,
      "pylonLower_engineeringAftOffset": 0.26,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.25,
      "name": "Greyhound class civil transport",
      "nacelle_lowerToggle": false,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 15.00,
      "nacelle_x": 3.4,
      "nacelle_z": -2.37,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 3.4,
      "nacelleLower_x": 3,
      "nacelleLower_z": 5.46,
      "nacelleLower_length": 12,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -28.45,
      "engineering_z": 7.04,
      "engineering_length": 26.85,
      "engineering_radius": 2.65,
      "engineering_widthRatio": 1,
      "engineering_skew": -0.36,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.04,
      "pylon_nacelleAftOffset": 0.54,
      "pylon_engineeringForeOffset": 0.7,
      "pylon_engineeringAftOffset": 0.13,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.92,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.45,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.74,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.4,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.74,
      "neck_primaryThickness": 0.74,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -7.33,
      "primary_z": -0.77,
      "primary_radius": 3.37,
      "primary_thickness": 4.56,
      "primary_widthRatio": 1.01,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 2.41,
      "primary_bridgeRadius": 1.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": -0.66,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "name": "NCC-23313 Bev's Crusher ",
    },
    {
      "primary_toggle": true,
      "primary_y": -3.94,
      "primary_z": -1.11,
      "primary_radius": 17.25,
      "primary_thickness": 7.95,
      "primary_widthRatio": 0.86,
      "primary_pointiness": 0.41,
      "primary_bridgeThickness": 0.87,
      "primary_bridgeRadius": 0.65,
      "primary_bridgeWidthRatio": 0.79,
      "primary_bridgeZ": 0.41,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0.32,
      "primary_notchAngleAft": 0,
      "sublight_toggle": true,
      "sublight_y": 8.53,
      "sublight_x": 3.23,
      "sublight_z": -1.37,
      "sublight_length": 12.23,
      "sublight_radius": 0.76,
      "sublight_widthRatio": 7.26,
      "sublight_rotation": 0.07,
      "sublight_segments": 3,
      "sublight_skewVertical": 0,
      "sublight_skewHorizontal": 0.21,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.74,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 2.96,
      "neck_thickness": 0.01,
      "neck_foretaper": 0.71,
      "neck_afttaper": 0.59,
      "engineering_toggle": true,
      "engineering_y": -19.35,
      "engineering_z": 1.9,
      "engineering_length": 31.13,
      "engineering_radius": 2.26,
      "engineering_widthRatio": 2.09,
      "engineering_skew": 2.04,
      "engineering_undercut": 0.78,
      "engineering_undercutStart": 0.45,
      "engineering_undercutCurve": 1,
      "engineering_dishRadius": 0.96,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 5.23,
      "nacelle_x": 8.91,
      "nacelle_z": 2.37,
      "nacelle_length": 23.99,
      "nacelle_radius": 2.01,
      "nacelle_widthRatio": 1.1,
      "nacelle_rotation": 0,
      "nacelle_skew": -0.81,
      "nacelle_undercutStart": 0.45,
      "nacelle_undercut": 1,
      "nacelle_bussardWidthRatio": 1,
      "nacelle_bussardRadius": 0.85,
      "nacelle_bussardCurvature": 1.34,
      "nacelle_bussardSkewVertical": -0.09,
      "nacelle_bussardYOffset": 0.27,
      "nacelle_bussardZOffset": 0.4,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.18,
      "pylon_nacelleAftOffset": 0.09,
      "pylon_engineeringForeOffset": 0.61,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": -0.65,
      "pylon_midPointOffset": 0.71,
      "pylon_thickness": 0.21,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 24.3,
      "nacelleLower_x": 0,
      "nacelleLower_z": 9.19,
      "nacelleLower_length": 30.16,
      "nacelleLower_radius": 3.25,
      "nacelleLower_widthRatio": 1.29,
      "nacelleLower_rotation": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.22,
      "nacelleLower_undercut": 1,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": -0.3,
      "pylonLower_nacelleAftOffset": 0.1,
      "pylonLower_engineeringForeOffset": 0.49,
      "pylonLower_engineeringAftOffset": 0.46,
      "pylonLower_engineeringZOffset": -0.86,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 1.16,
      "name": "Checkov's Sled V",
      "nacelle_lowerToggle": false,
      "primary_segments": 64,
      "primary_bridgeSegments": 64,
      "notchAngleAft": null
    },
    {
      "primary_toggle": true,
      "primary_y": 1.34,
      "primary_z": -2.05,
      "primary_radius": 17.95,
      "primary_thickness": 9.16,
      "primary_widthRatio": 0.83,
      "primary_pointiness": 0.41,
      "primary_bridgeThickness": 0.75,
      "primary_bridgeRadius": 0.68,
      "primary_bridgeWidthRatio": 0.59,
      "primary_bridgeZ": -1,
      "primary_bridgeY": -0.21,
      "primary_notchAngle": 0.32,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.74,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 2.96,
      "neck_thickness": 0.01,
      "neck_foretaper": 0.71,
      "neck_afttaper": 0.59,
      "engineering_toggle": true,
      "engineering_y": -13.04,
      "engineering_z": 1.9,
      "engineering_length": 30.98,
      "engineering_radius": 1.14,
      "engineering_widthRatio": 4.56,
      "engineering_skew": 2.04,
      "engineering_undercut": 0.78,
      "engineering_undercutStart": 0.45,
      "engineering_undercutCurve": 1,
      "engineering_dishRadius": 0.96,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": -1.51,
      "nacelle_x": 5.73,
      "nacelle_z": -1.19,
      "nacelle_length": 16.84,
      "nacelle_radius": 2.47,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": -0.57,
      "nacelle_undercutStart": 1,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.01,
      "pylon_nacelleAftOffset": 0.08,
      "pylon_engineeringForeOffset": 1.22,
      "pylon_engineeringAftOffset": -0.34,
      "pylon_engineeringZOffset": -4.53,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.21,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 2.8,
      "nacelleLower_x": -5.9,
      "nacelleLower_z": 3.36,
      "nacelleLower_length": 8.36,
      "nacelleLower_radius": 7.06,
      "nacelleLower_widthRatio": 0.25,
      "nacelleLower_rotation": -1.29,
      "nacelleLower_undercutStart": 1,
      "nacelleLower_undercut": 0.78,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": -0.3,
      "pylonLower_nacelleAftOffset": 0.65,
      "pylonLower_engineeringForeOffset": 1.18,
      "pylonLower_engineeringAftOffset": -0.34,
      "pylonLower_engineeringZOffset": -4.57,
      "pylonLower_midPointOffset": 0.45,
      "pylonLower_thickness": 0.24,
      "name": "NexusXmas V",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -5.31,
      "primary_z": 1.51,
      "primary_radius": 12,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.03,
      "primary_bridgeRadius": 0.36,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": -0.34,
      "primary_bridgeY": 0.01,
      "primary_notchAngle": 2.01,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0,
      "neck_primaryAftOffset": 0.27,
      "neck_engineeringForeOffset": 0.38,
      "neck_engineeringAftOffset": 0.33,
      "neck_primaryThickness": 2.8,
      "neck_thickness": 0.23,
      "neck_foretaper": 0.01,
      "neck_afttaper": 1.32,
      "engineering_toggle": true,
      "engineering_y": -25.66,
      "engineering_z": 0.66,
      "engineering_length": 13.37,
      "engineering_radius": 1.97,
      "engineering_widthRatio": 0.37,
      "engineering_skew": -0.07,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 7.46,
      "nacelle_x": 3.59,
      "nacelle_z": -3.27,
      "nacelle_length": 26.98,
      "nacelle_radius": 1.07,
      "nacelle_widthRatio": 0.59,
      "nacelle_rotation": -1.57,
      "pylon_toggle": false,
      "pylon_nacelleForeOffset": 0.01,
      "pylon_nacelleAftOffset": 0.86,
      "pylon_engineeringForeOffset": 0.83,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.99,
      "pylon_thickness": 0.67,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 22.04,
      "nacelleLower_x": 0,
      "nacelleLower_z": 7,
      "nacelleLower_length": 14.79,
      "nacelleLower_radius": 2.55,
      "nacelleLower_widthRatio": 0.47,
      "nacelleLower_rotation": -1.57,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.48,
      "pylonLower_engineeringForeOffset": 0,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.34,
      "pylonLower_thickness": 0.01,
      "name": "UnsolicitedDesignProposal",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -8.54,
      "primary_z": 0.5,
      "primary_radius": 12,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.4,
      "neck_primaryAftOffset": 0.02,
      "neck_engineeringForeOffset": 0.28,
      "neck_engineeringAftOffset": 0.27,
      "neck_primaryThickness": 0.76,
      "neck_thickness": 0.17,
      "neck_foretaper": 0.26,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -28.9,
      "engineering_z": 7.6,
      "engineering_length": 15.3,
      "engineering_radius": 1.8,
      "engineering_widthRatio": 1,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_undercutCurve": 3.47,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 18.78,
      "nacelle_x": 3.4,
      "nacelle_z": -6.34,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0.64,
      "nacelle_undercut": 0.75,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.44,
      "pylon_engineeringForeOffset": 0.31,
      "pylon_engineeringAftOffset": 0.47,
      "pylon_engineeringZOffset": 1.19,
      "pylon_midPointOffset": 0.31,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 13.61,
      "nacelleLower_x": 1.56,
      "nacelleLower_z": 2.33,
      "nacelleLower_length": 8.49,
      "nacelleLower_radius": 0.43,
      "nacelleLower_widthRatio": 9.88,
      "nacelleLower_rotation": -0.22,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.12,
      "pylonLower_thickness": 0.15,
      "name": "Belnassa",
      "nacelle_lowerToggle": false,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "primary_toggle": true,
      "primary_y": -8.78,
      "primary_z": -2.44,
      "primary_radius": 8.84,
      "primary_thickness": 7.28,
      "primary_widthRatio": 0.91,
      "primary_pointiness": 0.47,
      "primary_bridgeThickness": 0.77,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.62,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.07,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.22,
      "neck_primaryThickness": 1.58,
      "neck_thickness": 1.58,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -24.71,
      "engineering_z": 2.77,
      "engineering_length": 19.01,
      "engineering_radius": 3.16,
      "engineering_widthRatio": 0.95,
      "engineering_skew": -0.11,
      "engineering_undercut": 0.26,
      "engineering_undercutStart": 0.48,
      "engineering_undercutCurve": 5.24,
      "engineering_dishRadius": 0.86,
      "engineering_dishInset": 1.35,
      "nacelle_toggle": true,
      "nacelle_y": 16.25,
      "nacelle_x": 2.69,
      "nacelle_z": -2.22,
      "nacelle_length": 7.85,
      "nacelle_radius": 1.31,
      "nacelle_widthRatio": 1.41,
      "nacelle_rotation": 0.24,
      "nacelle_undercutStart": 0.82,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.25,
      "pylon_nacelleAftOffset": 0.2,
      "pylon_engineeringForeOffset": 0.26,
      "pylon_engineeringAftOffset": -0.04,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.37,
      "pylon_thickness": 0.12,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 15.83,
      "nacelleLower_x": 3.24,
      "nacelleLower_z": -0.01,
      "nacelleLower_length": 20.55,
      "nacelleLower_radius": 1.39,
      "nacelleLower_widthRatio": 0.58,
      "nacelleLower_rotation": 0.91,
      "nacelleLower_undercutStart": 0.11,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.21,
      "pylonLower_nacelleAftOffset": 0.68,
      "pylonLower_engineeringForeOffset": 0.25,
      "pylonLower_engineeringAftOffset": 0.26,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.25,
      "name": "Voyachonk",
      "nacelle_lowerToggle": false,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 19.5,
      "nacelle_x": 3.4,
      "nacelle_z": -0.44,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 40,
      "nacelleLower_x": 2.5,
      "nacelleLower_z": -3.5,
      "nacelleLower_length": 12,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -27.92,
      "engineering_z": 7.6,
      "engineering_length": 14.1,
      "engineering_radius": 2,
      "engineering_widthRatio": 1,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.19,
      "pylon_nacelleAftOffset": 0.73,
      "pylon_engineeringForeOffset": 0.72,
      "pylon_engineeringAftOffset": 0.16,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.15,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.56,
      "neck_primaryAftOffset": 0.05,
      "neck_engineeringForeOffset": 0.31,
      "neck_engineeringAftOffset": 0.43,
      "neck_thickness": 0.3,
      "neck_primaryThickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -8.46,
      "primary_z": 0.95,
      "primary_radius": 9,
      "primary_thickness": 3.06,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Ahcannaguarantee"
    },
    {  
      "primary_toggle": true,
      "primary_y": 0.91,
      "primary_z": -1.54,
      "primary_radius": 5.71,
      "primary_thickness": 2.53,
      "primary_widthRatio": 0.19,
      "primary_pointiness": 0.01,
      "primary_bridgeThickness": 5,
      "primary_bridgeRadius": 0.97,
      "primary_bridgeWidthRatio": 0.66,
      "primary_bridgeZ": 2,
      "primary_bridgeY": -0.33,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.29,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.42,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.35,
      "neck_thickness": 0.35,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -4.47,
      "engineering_z": 0.99,
      "engineering_length": 8.9,
      "engineering_radius": 1.78,
      "engineering_widthRatio": 0.83,
      "engineering_skew": -1.36,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 1.4,
      "nacelle_x": 2.52,
      "nacelle_z": -1.01,
      "nacelle_length": 15.43,
      "nacelle_radius": 0.86,
      "nacelle_widthRatio": 1.08,
      "nacelle_rotation": -0.47,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.17,
      "pylon_nacelleAftOffset": 0.47,
      "pylon_engineeringForeOffset": 0.77,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.25,
      "pylon_thickness": 0.12,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 2.67,
      "nacelleLower_x": 2.53,
      "nacelleLower_z": 1.46,
      "nacelleLower_length": 10.56,
      "nacelleLower_radius": 0.39,
      "nacelleLower_widthRatio": 2.69,
      "nacelleLower_rotation": -1.53,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0,
      "pylonLower_engineeringForeOffset": 0,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.07,
      "name": "Oreon Class",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -10.8,
      "primary_z": 1.21,
      "primary_radius": 16.75,
      "primary_thickness": 4.68,
      "primary_widthRatio": 0.86,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1,
      "primary_bridgeRadius": 0.3,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.11,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.67,
      "neck_engineeringAftOffset": 0.28,
      "neck_primaryThickness": 4.06,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "neck_thickness": 2.71,
      "engineering_toggle": true,
      "engineering_y": -24.95,
      "engineering_z": -0.01,
      "engineering_length": 10.48,
      "engineering_radius": 1.49,
      "engineering_widthRatio": 3.17,
      "engineering_skew": -0.02,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 13,
      "nacelle_x": 5.5,
      "nacelle_z": -7.07,
      "nacelle_length": 28.1,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.27,
      "pylon_nacelleAftOffset": 0.23,
      "pylon_engineeringForeOffset": 0.12,
      "pylon_engineeringAftOffset": 0.2,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.85,
      "pylon_thickness": 0.44,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 16.31,
      "nacelleLower_x": 1.97,
      "nacelleLower_z": -2.3,
      "nacelleLower_length": 7.87,
      "nacelleLower_radius": 0.66,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": -0.54,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.34,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.16,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 1.01,
      "pylonLower_thickness": 0.26,
      "boomLower_toggle": false,
      "name": "Unreliantable",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -17.63,
      "primary_z": 1.54,
      "primary_radius": 18.31,
      "primary_thickness": 4.81,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 0.78,
      "primary_bridgeRadius": 1.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": -0.77,
      "primary_bridgeY": 0.06,
      "primary_notchAngle": 2.62,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.12,
      "neck_primaryAftOffset": 0.18,
      "neck_engineeringForeOffset": 0.62,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 0.3,
      "neck_thickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -42.48,
      "engineering_z": 9.11,
      "engineering_length": 12.56,
      "engineering_radius": 1.5,
      "engineering_widthRatio": 2.63,
      "engineering_skew": 0,
      "engineering_undercut": 0.68,
      "engineering_undercutStart": 0.38,
      "engineering_undercutCurve": 3.47,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 21.85,
      "nacelle_x": 5.47,
      "nacelle_z": -10.99,
      "nacelle_length": 28.62,
      "nacelle_radius": 1.71,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0.64,
      "nacelle_undercut": 0.75,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.51,
      "pylon_nacelleAftOffset": 0.74,
      "pylon_engineeringForeOffset": -0.17,
      "pylon_engineeringAftOffset": 1.5,
      "pylon_engineeringZOffset": -6,
      "pylon_midPointOffset": 0.61,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 29.66,
      "nacelleLower_x": 5.52,
      "nacelleLower_z": 10.94,
      "nacelleLower_length": 16.99,
      "nacelleLower_radius": 0.79,
      "nacelleLower_widthRatio": 6.81,
      "nacelleLower_rotation": 0.2,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.33,
      "pylonLower_nacelleAftOffset": 0.24,
      "pylonLower_engineeringForeOffset": 0.28,
      "pylonLower_engineeringAftOffset": 0.26,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.26,
      "pylonLower_thickness": 0.26,
      "name": "PanchachosQuatros",
      "nacelle_lowerToggle": false,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "primary_toggle": true,
      "primary_y": -6.76,
      "primary_z": -0.21,
      "primary_radius": 6.83,
      "primary_thickness": 4.03,
      "primary_widthRatio": 0.74,
      "primary_pointiness": 0.64,
      "primary_bridgeThickness": 0.5,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 0.69,
      "primary_bridgeZ": -0.75,
      "primary_bridgeY": 0,
      "primary_bridgeY": -0.79,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.54,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.28,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 1.68,
      "neck_thickness": 1.07,
      "neck_foretaper": 1.3,
      "neck_afttaper": 0.5,
      "engineering_toggle": true,
      "engineering_y": -20.87,
      "engineering_z": 4.26,
      "engineering_length": 13.79,
      "engineering_radius": 1.12,
      "engineering_widthRatio": 1.6,
      "engineering_skew": -0.86,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 12.66,
      "nacelle_x": 2,
      "nacelle_z": -3.16,
      "nacelle_length": 8.06,
      "nacelle_radius": 0.82,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": -0.54,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.08,
      "pylon_nacelleAftOffset": 0.58,
      "pylon_engineeringForeOffset": 0.61,
      "pylon_engineeringAftOffset": 0.01,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.56,
      "pylon_thickness": 0.2,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 26.24,
      "nacelleLower_x": 1.64,
      "nacelleLower_z": -2.3,
      "nacelleLower_length": 7.87,
      "nacelleLower_radius": 0.66,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.37,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.1,
      "name": "Jauntinger",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -13.13,
      "primary_z": 4.48,
      "primary_radius": 12,
      "primary_thickness": 5.52,
      "primary_widthRatio": 0.54,
      "primary_pointiness": 0.24,
      "primary_bridgeThickness": 1.1,
      "primary_bridgeRadius": 1.06,
      "primary_bridgeWidthRatio": 0.49,
      "primary_bridgeZ": 0.77,
      "primary_bridgeY": 0.37,
      "primary_notchAngle": 0.45,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.57,
      "neck_primaryAftOffset": -0.15,
      "neck_engineeringForeOffset": 0.11,
      "neck_engineeringAftOffset": 0.45,
      "neck_primaryThickness": 2.5,
      "neck_thickness": 3.73,
      "neck_foretaper": 0.37,
      "neck_afttaper": 0.08,
      "engineering_toggle": true,
      "engineering_y": -32.44,
      "engineering_z": 7.81,
      "engineering_length": 26.73,
      "engineering_radius": 3.44,
      "engineering_widthRatio": 0.79,
      "engineering_skew": -0.83,
      "engineering_undercut": 1,
      "engineering_undercutStart": 0.35,
      "engineering_undercutCurve": 6.64,
      "engineering_dishRadius": 0.71,
      "engineering_dishInset": 0.98,
      "nacelle_toggle": true,
      "nacelle_y": 22.62,
      "nacelle_x": 2.8,
      "nacelle_z": -3.26,
      "nacelle_length": 12.82,
      "nacelle_radius": 2.18,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.51,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.05,
      "pylon_nacelleAftOffset": 0.81,
      "pylon_engineeringForeOffset": 0.58,
      "pylon_engineeringAftOffset": 0.29,
      "pylon_engineeringZOffset": -1.24,
      "pylon_midPointOffset": 0.68,
      "pylon_thickness": 0.29,
      "nacelleLower_toggle": false,
      "nacelleLower_y": -6.53,
      "nacelleLower_x": 7.36,
      "nacelleLower_z": 12.13,
      "nacelleLower_length": 22.2,
      "nacelleLower_radius": 2.62,
      "nacelleLower_widthRatio": 0.44,
      "nacelleLower_rotation": -0.27,
      "nacelleLower_undercutStart": 0.29,
      "nacelleLower_undercut": 0.8,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": -0.18,
      "pylonLower_nacelleAftOffset": 0.59,
      "pylonLower_engineeringForeOffset": 0.14,
      "pylonLower_engineeringAftOffset": 0.59,
      "pylonLower_engineeringZOffset": 1.25,
      "pylonLower_midPointOffset": 0.33,
      "pylonLower_thickness": 0.3,
      "name": "Pondrazer",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -8.78,
      "primary_z": -0.8,
      "primary_radius": 10.98,
      "primary_thickness": 3.49,
      "primary_widthRatio": 0.54,
      "primary_pointiness": 0.43,
      "primary_bridgeThickness": 1,
      "primary_bridgeRadius": 0.84,
      "primary_bridgeWidthRatio": 0.54,
      "primary_bridgeZ": 0,
      "primary_bridgeY": 0,
      "primary_notchAngle": 2.18,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.29,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.42,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.35,
      "neck_thickness": 0.35,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -16.62,
      "engineering_z": 0.67,
      "engineering_length": 10.3,
      "engineering_radius": 1.12,
      "engineering_widthRatio": 2.47,
      "engineering_skew": 1.16,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_undercutCurve": 3.23,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 9.5,
      "nacelle_x": 0,
      "nacelle_z": 4.53,
      "nacelle_length": 14.85,
      "nacelle_radius": 0.93,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0.26,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.64,
      "pylon_nacelleAftOffset": 0.11,
      "pylon_engineeringForeOffset": 0.5,
      "pylon_engineeringAftOffset": 0.24,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 9.69,
      "nacelleLower_x": 2.63,
      "nacelleLower_z": 4.11,
      "nacelleLower_length": 14.74,
      "nacelleLower_radius": 0.91,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_undercutStart": 0.22,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.76,
      "pylonLower_nacelleAftOffset": 0.13,
      "pylonLower_engineeringForeOffset": 0.28,
      "pylonLower_engineeringAftOffset": 0.19,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.25,
      "name": "Triple Twains",
      "nacelle_lowerToggle": false,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "primary_segments": 64,
      "primary_bridgeSegments": 64
    },
    {
      "primary_toggle": true,
      "primary_y": -10.01,
      "primary_z": 2.43,
      "primary_radius": 15.57,
      "primary_thickness": 6.23,
      "primary_widthRatio": 0.54,
      "primary_pointiness": 0.61,
      "primary_bridgeThickness": 0.5,
      "primary_bridgeRadius": 0.01,
      "primary_bridgeWidthRatio": 0.96,
      "primary_bridgeZ": -1,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0.28,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.74,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 5,
      "neck_thickness": 0.01,
      "neck_foretaper": 1.21,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -29.02,
      "engineering_z": 4.57,
      "engineering_length": 33.03,
      "engineering_radius": 2.62,
      "engineering_widthRatio": 1,
      "engineering_skew": 1.22,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.45,
      "engineering_undercutCurve": 3.23,
      "engineering_dishRadius": 1.1,
      "engineering_dishInset": 0.13,
      "nacelle_toggle": true,
      "nacelle_y": 14.41,
      "nacelle_x": 5.64,
      "nacelle_z": 2.25,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": -0.99,
      "nacelle_undercutStart": 0.26,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 0.8,
      "pylon_engineeringForeOffset": 0.54,
      "pylon_engineeringAftOffset": 0.2,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 13.99,
      "nacelleLower_x": 0,
      "nacelleLower_z": 15,
      "nacelleLower_length": 23.09,
      "nacelleLower_radius": 1.4,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 3.14,
      "nacelleLower_undercutStart": 0.22,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.8,
      "pylonLower_engineeringForeOffset": 0.55,
      "pylonLower_engineeringAftOffset": 0.17,
      "pylonLower_engineeringZOffset": -0.56,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.45,
      "name": "Shake's Spear",
      "nacelle_lowerToggle": false,
      "primary_segments": 64,
      "primary_bridgeSegments": 64,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0
    },
    {
      "primary_toggle": true,
      "primary_y": -6.56,
      "primary_z": -0.34,
      "primary_radius": 15.66,
      "primary_thickness": 9.31,
      "primary_widthRatio": 0.58,
      "primary_pointiness": 0.99,
      "primary_bridgeThickness": 0.5,
      "primary_bridgeRadius": 0.31,
      "primary_bridgeWidthRatio": 0.67,
      "primary_bridgeZ": -1,
      "primary_bridgeY": -0.26,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.37,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 2.3,
      "neck_thickness": 0.98,
      "neck_foretaper": 1,
      "neck_afttaper": 1.51,
      "engineering_toggle": true,
      "engineering_y": -24.21,
      "engineering_z": 5.86,
      "engineering_length": 27.43,
      "engineering_radius": 3.91,
      "engineering_widthRatio": 0.95,
      "engineering_skew": -2.1,
      "engineering_undercut": 0.73,
      "engineering_undercutStart": 0.12,
      "engineering_undercutCurve": 2.8,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 9.47,
      "nacelle_x": -3.08,
      "nacelle_z": -9.4,
      "nacelle_length": 18.04,
      "nacelle_radius": 2.16,
      "nacelle_widthRatio": 0.95,
      "nacelle_rotation": -0.02,
      "nacelle_undercutStart": 0.15,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.15,
      "pylon_nacelleAftOffset": 0.5,
      "pylon_engineeringForeOffset": 0.43,
      "pylon_engineeringAftOffset": 0.47,
      "pylon_engineeringZOffset": 0.66,
      "pylon_midPointOffset": 0.52,
      "pylon_thickness": 0.52,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 30,
      "nacelleLower_x": 7.77,
      "nacelleLower_z": 12.87,
      "nacelleLower_length": 8.48,
      "nacelleLower_radius": 1.09,
      "nacelleLower_widthRatio": 0.38,
      "nacelleLower_rotation": 0.79,
      "nacelleLower_undercutStart": 0.2,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": -0.24,
      "pylonLower_nacelleAftOffset": 0.84,
      "pylonLower_engineeringForeOffset": 0.15,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": -2.91,
      "pylonLower_midPointOffset": 0.22,
      "pylonLower_thickness": 0.29,
      "name": "Fox River Gold",
      "nacelle_lowerToggle": false,
      "primary_segments": 64,
      "primary_bridgeSegments": 64,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0
    },
    {
      "primary_toggle": true,
      "primary_y": -2.19,
      "primary_z": -1.75,
      "primary_radius": 17.71,
      "primary_thickness": 4.68,
      "primary_widthRatio": 0.76,
      "primary_pointiness": 0.44,
      "primary_bridgeThickness": 1.01,
      "primary_bridgeRadius": 0.46,
      "primary_bridgeWidthRatio": 0.66,
      "primary_bridgeZ": 0.14,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0.5,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.3,
      "neck_thickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -17.06,
      "engineering_z": 0.47,
      "engineering_length": 24.3,
      "engineering_radius": 1.29,
      "engineering_widthRatio": 7.32,
      "engineering_skew": -0.22,
      "engineering_undercut": 0.72,
      "engineering_undercutStart": 0.12,
      "engineering_undercutCurve": 6.93,
      "engineering_dishRadius": 0.81,
      "engineering_dishInset": 0.85,
      "nacelle_toggle": true,
      "nacelle_y": 16.66,
      "nacelle_x": -1.06,
      "nacelle_z": 4.33,
      "nacelle_length": 18.77,
      "nacelle_radius": 1.56,
      "nacelle_widthRatio": 0.99,
      "nacelle_rotation": -0.06,
      "nacelle_undercutStart": 0.23,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.19,
      "pylon_nacelleAftOffset": 0.5,
      "pylon_engineeringForeOffset": 0.44,
      "pylon_engineeringAftOffset": 0.15,
      "pylon_engineeringZOffset": 0.05,
      "pylon_midPointOffset": 0.32,
      "pylon_thickness": 0.27,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 19.26,
      "nacelleLower_x": -3.29,
      "nacelleLower_z": -2.94,
      "nacelleLower_length": 18.44,
      "nacelleLower_radius": 1.56,
      "nacelleLower_widthRatio": 1.06,
      "nacelleLower_rotation": -0.04,
      "nacelleLower_undercutStart": 0.11,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.2,
      "pylonLower_nacelleAftOffset": 0.49,
      "pylonLower_engineeringForeOffset": 0.45,
      "pylonLower_engineeringAftOffset": 0.17,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.52,
      "pylonLower_thickness": 0.27,
      "name": "Hell's Nacelles",
      "nacelle_lowerToggle": false,
      "primary_segments": 64,
      "primary_bridgeSegments": 64,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0
    },
    {
      "primary_toggle": true,
      "primary_y": -1.54,
      "primary_z": 0.44,
      "primary_radius": 8.57,
      "primary_thickness": 3.97,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 0.96,
      "primary_bridgeRadius": 0.11,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": -0.44,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0.29,
      "primary_notchAngleAft": 0,
      "sublight_toggle": true,
      "sublight_y": 0.36,
      "sublight_x": 1.42,
      "sublight_z": -1.54,
      "sublight_length": 15.06,
      "sublight_radius": 0.64,
      "sublight_widthRatio": 3.1,
      "sublight_rotation": -0.42,
      "sublight_segments": 3,
      "sublight_skewVertical": 0,
      "sublight_skewHorizontal": 1,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.2,
      "neck_thickness": 0.2,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -20.85,
      "engineering_z": 1.91,
      "engineering_length": 26.54,
      "engineering_radius": 0.95,
      "engineering_widthRatio": 2.56,
      "engineering_skew": 2.34,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_undercutCurve": 4.91,
      "engineering_dishRadius": 1.03,
      "engineering_dishInset": 0.12,
      "nacelle_toggle": true,
      "nacelle_y": 12.12,
      "nacelle_x": 4.78,
      "nacelle_z": -5.41,
      "nacelle_length": 23.09,
      "nacelle_radius": 0.89,
      "nacelle_widthRatio": 0.88,
      "nacelle_rotation": 1.03,
      "nacelle_skew": -1.5,
      "nacelle_undercutStart": 0.18,
      "nacelle_undercut": 0.71,
      "nacelle_bussardWidthRatio": 0.57,
      "nacelle_bussardRadius": 1.24,
      "nacelle_bussardCurvature": 2.01,
      "nacelle_bussardSkewVertical": -1.33,
      "nacelle_bussardYOffset": 1.01,
      "nacelle_bussardZOffset": -0.6,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.58,
      "pylon_engineeringForeOffset": 0.5,
      "pylon_engineeringAftOffset": 0.2,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.27,
      "pylon_thickness": 0.13,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 12.55,
      "nacelleLower_x": 3.57,
      "nacelleLower_z": 4.29,
      "nacelleLower_length": 8.36,
      "nacelleLower_radius": 0.53,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0.45,
      "pylonLower_midPointOffset": 0.27,
      "pylonLower_thickness": 0.13,
      "name": "ShenJeave",
      "notchAngleAft": null,
      "nacelle_lowerToggle": false,
      "primary_segments": 34.01,
      "primary_bridgeSegments": 34.01
    },
    {
      "primary_toggle": true,
      "primary_y": -8.16,
      "primary_z": 0.86,
      "primary_radius": 15.57,
      "primary_thickness": 9.92,
      "primary_widthRatio": 0.54,
      "primary_pointiness": 0.61,
      "primary_bridgeThickness": 1.04,
      "primary_bridgeRadius": 0.49,
      "primary_bridgeWidthRatio": 0.53,
      "primary_bridgeZ": 0.18,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0.28,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.74,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 5,
      "neck_thickness": 0.01,
      "neck_foretaper": 1.21,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -33.72,
      "engineering_z": 6.14,
      "engineering_length": 38.96,
      "engineering_radius": 2.62,
      "engineering_widthRatio": 1,
      "engineering_skew": -1.6,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.45,
      "engineering_undercutCurve": 3.23,
      "engineering_dishRadius": 1.1,
      "engineering_dishInset": 0.13,
      "nacelle_toggle": true,
      "nacelle_y": 21.82,
      "nacelle_x": -0.02,
      "nacelle_z": 2.25,
      "nacelle_length": 36.33,
      "nacelle_radius": 2.24,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0.26,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.1,
      "pylon_nacelleAftOffset": 0.62,
      "pylon_engineeringForeOffset": 0.54,
      "pylon_engineeringAftOffset": 0.35,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 21.66,
      "nacelleLower_x": 0,
      "nacelleLower_z": 15,
      "nacelleLower_length": 36.16,
      "nacelleLower_radius": 2.2,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 3.14,
      "nacelleLower_undercutStart": 0.22,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.12,
      "pylonLower_nacelleAftOffset": 0.56,
      "pylonLower_engineeringForeOffset": 0.55,
      "pylonLower_engineeringAftOffset": 0.36,
      "pylonLower_engineeringZOffset": -0.56,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.45,
      "name": "USS Inanimate Carbon Rod",
      "nacelle_lowerToggle": false,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "primary_toggle": true,
      "primary_y": -8.53,
      "primary_z": 0.44,
      "primary_radius": 18.1,
      "primary_thickness": 6.05,
      "primary_widthRatio": 0.98,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 0.96,
      "primary_bridgeRadius": 1.2,
      "primary_bridgeWidthRatio": 0.53,
      "primary_bridgeZ": -0.02,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.74,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 3.65,
      "neck_thickness": 0.01,
      "neck_foretaper": 0.88,
      "neck_afttaper": 0.73,
      "engineering_toggle": true,
      "engineering_y": -36.57,
      "engineering_z": -2.55,
      "engineering_length": 17.59,
      "engineering_radius": 4.17,
      "engineering_widthRatio": 0.66,
      "engineering_skew": -0.86,
      "engineering_undercut": 0.78,
      "engineering_undercutStart": 0.45,
      "engineering_undercutCurve": 1,
      "engineering_dishRadius": 0.96,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 18.15,
      "nacelle_x": 0,
      "nacelle_z": 3.45,
      "nacelle_length": 33.85,
      "nacelle_radius": 2.11,
      "nacelle_widthRatio": 1.1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0.84,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.1,
      "pylon_nacelleAftOffset": 0.19,
      "pylon_engineeringForeOffset": 0.61,
      "pylon_engineeringAftOffset": -0.09,
      "pylon_engineeringZOffset": 2.22,
      "pylon_midPointOffset": 2,
      "pylon_thickness": 0.26,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 3.8,
      "nacelleLower_x": -6.88,
      "nacelleLower_z": 2.76,
      "nacelleLower_length": 26.36,
      "nacelleLower_radius": 1.6,
      "nacelleLower_widthRatio": 1.9,
      "nacelleLower_rotation": 3.14,
      "nacelleLower_undercutStart": 0.22,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.12,
      "pylonLower_nacelleAftOffset": 0.36,
      "pylonLower_engineeringForeOffset": 0.62,
      "pylonLower_engineeringAftOffset": 0.22,
      "pylonLower_engineeringZOffset": -0.86,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.41,
      "name": "La Belle Nacelle V",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -10,
      "primary_z": 0.5,
      "primary_radius": 12,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.11,
      "primary_bridgeRadius": 0.5,
      "primary_bridgeWidthRatio": 0.58,
      "primary_bridgeZ": 0.38,
      "primary_bridgeY": 0.21,
      "primary_notchAngle": 0.57,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 0.3,
      "neck_thickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -20,
      "engineering_z": 2.25,
      "engineering_length": 15.3,
      "engineering_radius": 1.36,
      "engineering_widthRatio": 4.29,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 4.12,
      "nacelle_x": -4.05,
      "nacelle_z": -2.62,
      "nacelle_length": 17.29,
      "nacelle_radius": 1.6,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": -0.95,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.45,
      "pylon_engineeringForeOffset": 0.56,
      "pylon_engineeringAftOffset": 0.19,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.4,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 11,
      "nacelleLower_x": 5.27,
      "nacelleLower_z": 3.91,
      "nacelleLower_length": 16.02,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.21,
      "pylonLower_thickness": 0.29,
      "name": "Pach'mahn",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -9.91,
      "primary_z": 0.88,
      "primary_radius": 18.81,
      "primary_thickness": 7.92,
      "primary_widthRatio": 0.78,
      "primary_pointiness": 0.48,
      "primary_segments": 64,
      "primary_bridgeThickness": 0.8,
      "primary_bridgeRadius": 0.76,
      "primary_bridgeWidthRatio": 0.92,
      "primary_bridgeZ": -0.17,
      "primary_bridgeY": -0.06,
      "primary_bridgeSegments": 64,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 1.81,
      "neck_thickness": 1.27,
      "neck_foretaper": 1.49,
      "neck_afttaper": 1.17,
      "engineering_toggle": true,
      "engineering_y": -36.57,
      "engineering_z": 9.58,
      "engineering_length": 24.65,
      "engineering_radius": 2.14,
      "engineering_widthRatio": 2.27,
      "engineering_skew": -1.49,
      "engineering_undercut": 0.41,
      "engineering_undercutStart": 0.35,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 26.5,
      "nacelle_x": 4.97,
      "nacelle_z": -2.46,
      "nacelle_length": 25.68,
      "nacelle_radius": 1.63,
      "nacelle_widthRatio": 0.8,
      "nacelle_rotation": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.25,
      "pylon_nacelleAftOffset": 0.32,
      "pylon_engineeringForeOffset": 0.64,
      "pylon_engineeringAftOffset": 0.17,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.43,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 13.15,
      "nacelleLower_x": -3.15,
      "nacelleLower_z": 4.55,
      "nacelleLower_length": 8.11,
      "nacelleLower_radius": 0.43,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": -0.3,
      "pylonLower_nacelleAftOffset": 0.27,
      "pylonLower_engineeringForeOffset": 0.32,
      "pylonLower_engineeringAftOffset": 0.18,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.68,
      "pylonLower_thickness": 0.3,
      "name": "Homer's Odysseus",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "primary_toggle": true,
      "primary_y": -20.62,
      "primary_z": 1.37,
      "primary_radius": 15.97,
      "primary_thickness": 4.57,
      "primary_widthRatio": 1.3,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "primary_notchAngleAft": 0,
      "primary_windowsY": 0,
      "primary_windowsRepeatY": 2,
      "primary_windowsRepeatX": 4,
      "sublight_toggle": true,
      "sublight_y": 28.61,
      "sublight_x": 0.96,
      "sublight_z": -3.66,
      "sublight_length": 7.99,
      "sublight_radius": 0.56,
      "sublight_widthRatio": 5,
      "sublight_rotation": 0,
      "sublight_segments": 4,
      "sublight_skewVertical": 0,
      "sublight_skewHorizontal": 0.2,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.57,
      "neck_primaryAftOffset": 0.03,
      "neck_engineeringForeOffset": 0.17,
      "neck_engineeringAftOffset": 0.29,
      "neck_primaryThickness": 2.51,
      "neck_thickness": 0.01,
      "neck_foretaper": 0.33,
      "neck_afttaper": 1.84,
      "engineering_toggle": true,
      "engineering_y": -49.01,
      "engineering_z": 10.12,
      "engineering_length": 17.48,
      "engineering_radius": 2.14,
      "engineering_widthRatio": 2.44,
      "engineering_skew": -0.37,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_undercutCurve": 1.75,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "engineering_edgeSharpness": 0,
      "nacelle_toggle": true,
      "nacelle_y": 36.05,
      "nacelle_x": 4.53,
      "nacelle_z": -6.6,
      "nacelle_length": 17.53,
      "nacelle_radius": 1.12,
      "nacelle_widthRatio": 1.95,
      "nacelle_rotation": 0,
      "nacelle_segments": 32,
      "nacelle_skew": 0,
      "nacelle_undercutStart": 0.53,
      "nacelle_undercut": 0.75,
      "nacelle_bussardWidthRatio": 1,
      "nacelle_bussardRadius": 1,
      "nacelle_bussardCurvature": 1,
      "nacelle_bussardSkewVertical": 0,
      "nacelle_bussardYOffset": 0,
      "nacelle_bussardZOffset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.23,
      "pylon_nacelleAftOffset": 0.41,
      "pylon_engineeringForeOffset": 0.67,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.76,
      "pylon_thickness": 0.11,
      "pylon_curvature": 0.17,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 17.84,
      "nacelleLower_x": 5.78,
      "nacelleLower_z": -3.39,
      "nacelleLower_length": 30.63,
      "nacelleLower_radius": 3.87,
      "nacelleLower_widthRatio": 0.39,
      "nacelleLower_rotation": -0.93,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "nacelleLower_undercutStart": 0.9,
      "nacelleLower_undercut": 0.75,
      "nacelleLower_bussardWidthRatio": 1,
      "nacelleLower_bussardRadius": 1,
      "nacelleLower_bussardCurvature": 1,
      "nacelleLower_bussardSkewVertical": 0,
      "nacelleLower_bussardYOffset": 0,
      "nacelleLower_bussardZOffset": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.69,
      "pylonLower_nacelleAftOffset": 0.19,
      "pylonLower_engineeringForeOffset": 0.44,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.16,
      "pylonLower_curvature": 0.01,
      "name": "Earlgrey",
      "notchAngleAft": null,
      "nacelle_lowerToggle": false,
      "pylonUpper_curvature": null
    },
    {
      "primary_toggle": true,
      "primary_y": 0.58,
      "primary_z": 1.09,
      "primary_radius": 3.47,
      "primary_thickness": 2.8,
      "primary_widthRatio": 0.73,
      "primary_pointiness": 0.81,
      "primary_bridgeThickness": 0.5,
      "primary_bridgeRadius": 0.11,
      "primary_bridgeWidthRatio": 1.22,
      "primary_bridgeZ": -1,
      "primary_bridgeY": 0.16,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.74,
      "neck_primaryAftOffset": 0.28,
      "neck_engineeringForeOffset": 0.91,
      "neck_engineeringAftOffset": 0.75,
      "neck_primaryThickness": 4.21,
      "neck_thickness": 4.41,
      "neck_foretaper": 0.01,
      "neck_afttaper": 1.14,
      "engineering_toggle": true,
      "engineering_y": -7.63,
      "engineering_z": 3.43,
      "engineering_length": 8.26,
      "engineering_radius": 1.53,
      "engineering_widthRatio": 0.82,
      "engineering_skew": -0.72,
      "engineering_undercut": 0.7,
      "engineering_undercutStart": 0.33,
      "engineering_undercutCurve": 4.07,
      "engineering_dishRadius": 0.97,
      "engineering_dishInset": 0.41,
      "nacelle_toggle": false,
      "nacelle_y": -4.12,
      "nacelle_x": 2.44,
      "nacelle_z": -3.09,
      "nacelle_length": 9.07,
      "nacelle_radius": 2.38,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": -0.01,
      "nacelle_undercutStart": 0.1,
      "nacelle_undercut": 0.41,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.39,
      "pylon_nacelleAftOffset": 0.38,
      "pylon_engineeringForeOffset": 0.29,
      "pylon_engineeringAftOffset": 0.62,
      "pylon_engineeringZOffset": 6,
      "pylon_midPointOffset": 0.32,
      "pylon_thickness": 0.18,
      "nacelleLower_toggle": true,
      "nacelleLower_y": -4.12,
      "nacelleLower_x": 2.48,
      "nacelleLower_z": 3.09,
      "nacelleLower_length": 6.73,
      "nacelleLower_radius": 0.9,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": -0.17,
      "nacelleLower_undercutStart": 0,
      "nacelleLower_undercut": 0.66,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.32,
      "pylonLower_nacelleAftOffset": 0.17,
      "pylonLower_engineeringForeOffset": 0.93,
      "pylonLower_engineeringAftOffset": -0.07,
      "pylonLower_engineeringZOffset": -5,
      "pylonLower_midPointOffset": 0.59,
      "pylonLower_thickness": 0.18,
      "name": "Rollbaro",
      "nacelle_lowerToggle": false,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "primary_toggle": true,
      "primary_y": -14.32,
      "primary_z": 0.48,
      "primary_radius": 12,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_segments": 64,
      "primary_bridgeThickness": 1.12,
      "primary_bridgeRadius": 0.42,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.24,
      "primary_bridgeY": 0,
      "primary_bridgeSegments": 64,
      "primary_notchAngle": 0.39,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 0.3,
      "neck_thickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -24.81,
      "engineering_z": 2.41,
      "engineering_length": 20.41,
      "engineering_radius": 1.08,
      "engineering_widthRatio": 6.15,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 0.87,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 26.5,
      "nacelle_x": 4.78,
      "nacelle_z": 1.14,
      "nacelle_length": 14.94,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.38,
      "pylon_nacelleAftOffset": 0.2,
      "pylon_engineeringForeOffset": 1.14,
      "pylon_engineeringAftOffset": -0.3,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.45,
      "pylon_thickness": 0.32,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 14.68,
      "nacelleLower_x": 2.39,
      "nacelleLower_z": 2.12,
      "nacelleLower_length": 17.33,
      "nacelleLower_radius": 1.49,
      "nacelleLower_widthRatio": 1.27,
      "nacelleLower_rotation": 1.57,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.69,
      "pylonLower_nacelleAftOffset": 0,
      "pylonLower_engineeringForeOffset": 0.87,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.84,
      "pylonLower_thickness": 0.16,
      "name": "NX Long Road ",
      "nacelle_lowerToggle": false,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0
    },
    {
      "primary_toggle": true,
      "primary_y": -1.18,
      "primary_z": -0.91,
      "primary_radius": 19.76,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_segments": 64,
      "primary_bridgeThickness": 1.49,
      "primary_bridgeRadius": 0.51,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.13,
      "primary_bridgeY": 0,
      "primary_bridgeSegments": 64,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.62,
      "neck_primaryAftOffset": 0.05,
      "neck_engineeringForeOffset": 0.09,
      "neck_engineeringAftOffset": 0.53,
      "neck_primaryThickness": 1.74,
      "neck_thickness": 1.6,
      "neck_foretaper": 0.26,
      "neck_afttaper": 1.27,
      "engineering_toggle": true,
      "engineering_y": -35.7,
      "engineering_z": 7.81,
      "engineering_length": 26.73,
      "engineering_radius": 3.11,
      "engineering_widthRatio": 1.02,
      "engineering_skew": -0.48,
      "engineering_undercut": 0.66,
      "engineering_undercutStart": 0.55,
      "engineering_dishRadius": 0.94,
      "engineering_dishInset": 0.74,
      "nacelle_toggle": true,
      "nacelle_y": 18.42,
      "nacelle_x": 5.04,
      "nacelle_z": -2.79,
      "nacelle_length": 20.85,
      "nacelle_radius": 1.81,
      "nacelle_widthRatio": 1.36,
      "nacelle_rotation": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.3,
      "pylon_nacelleAftOffset": 0.43,
      "pylon_engineeringForeOffset": 0.48,
      "pylon_engineeringAftOffset": 0.32,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.99,
      "pylon_thickness": 0.67,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 13.1,
      "nacelleLower_x": 3.86,
      "nacelleLower_z": 8.06,
      "nacelleLower_length": 20.92,
      "nacelleLower_radius": 0.43,
      "nacelleLower_widthRatio": 0.33,
      "nacelleLower_rotation": -1.57,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.52,
      "pylonLower_nacelleAftOffset": 0.38,
      "pylonLower_engineeringForeOffset": 0.38,
      "pylonLower_engineeringAftOffset": 0.01,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.39,
      "pylonLower_thickness": 0.21,
      "name": "Garret's Delorean",
      "nacelle_lowerToggle": false,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 10.2,
      "nacelle_x": 0,
      "nacelle_z": -6.64,
      "nacelle_length": 28.62,
      "nacelle_radius": 1.71,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 17.84,
      "nacelleLower_x": 5.78,
      "nacelleLower_z": -3.39,
      "nacelleLower_length": 30.63,
      "nacelleLower_radius": 3.87,
      "nacelleLower_widthRatio": 0.39,
      "nacelleLower_rotation": -0.93,
      "engineering_toggle": true,
      "engineering_y": -37.58,
      "engineering_z": -1.9,
      "engineering_length": 23.05,
      "engineering_radius": 2.2,
      "engineering_widthRatio": 1,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.46,
      "pylon_nacelleAftOffset": 0.12,
      "pylon_engineeringForeOffset": 0.19,
      "pylon_engineeringAftOffset": 0.71,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.69,
      "pylonLower_nacelleAftOffset": 0.19,
      "pylonLower_engineeringForeOffset": 0.44,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_thickness": 0.16,
      "boomLower_toggle": false,
      "pylonLower_midPointOffset": 0.1,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.6,
      "neck_primaryThickness": 0.6,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -10,
      "primary_z": 0.5,
      "primary_radius": 14.81,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Celcius",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": 4.06,
      "primary_z": 4.33,
      "primary_radius": 2.43,
      "primary_thickness": 4.85,
      "primary_widthRatio": 0.55,
      "primary_pointiness": 0.53,
      "primary_bridgeThickness": 0.6,
      "primary_bridgeRadius": 0.97,
      "primary_bridgeWidthRatio": 0.65,
      "primary_bridgeZ": -0.24,
      "primary_bridgeY": 0.39,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.22,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.18,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.01,
      "neck_thickness": 3.04,
      "neck_foretaper": 0.56,
      "neck_afttaper": 0.01,
      "engineering_toggle": true,
      "engineering_y": -13.68,
      "engineering_z": 4.33,
      "engineering_length": 7.88,
      "engineering_radius": 2.01,
      "engineering_widthRatio": 1.01,
      "engineering_skew": -0.77,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 7.17,
      "nacelle_x": 1.63,
      "nacelle_z": -3.11,
      "nacelle_length": 6.33,
      "nacelle_radius": 1.78,
      "nacelle_widthRatio": 0.54,
      "nacelle_rotation": 0.73,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.66,
      "pylon_nacelleAftOffset": 0,
      "pylon_engineeringForeOffset": 0.29,
      "pylon_engineeringAftOffset": 0.24,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.73,
      "pylon_thickness": 0.92,
      "nacelleLower_toggle": false,
      "nacelleLower_y": -3.22,
      "nacelleLower_x": 6,
      "nacelleLower_z": 8.92,
      "nacelleLower_length": 6.69,
      "nacelleLower_radius": 0.5,
      "nacelleLower_widthRatio": 0.59,
      "nacelleLower_rotation": -0.23,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.55,
      "pylonLower_nacelleAftOffset": 0,
      "pylonLower_engineeringForeOffset": 0.2,
      "pylonLower_engineeringAftOffset": 0.06,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.39,
      "pylonLower_thickness": 0.2,
      "name": "Sparrow of Prey",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": 6.9,
      "primary_z": 2.16,
      "primary_radius": 1.79,
      "primary_thickness": 1.78,
      "primary_widthRatio": 1.34,
      "primary_pointiness": -1,
      "primary_bridgeThickness": 2.84,
      "primary_bridgeRadius": 0.35,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": -0.36,
      "primary_bridgeY": 0,
      "primary_bridgeY": 0.9,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.06,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.33,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.74,
      "neck_thickness": 0.74,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -13.73,
      "engineering_z": 1.88,
      "engineering_length": 8.89,
      "engineering_radius": 1.34,
      "engineering_widthRatio": 2.99,
      "engineering_skew": -0.37,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 9.23,
      "nacelle_x": 5.63,
      "nacelle_z": -5.71,
      "nacelle_length": 10.98,
      "nacelle_radius": 1.29,
      "nacelle_widthRatio": 0.52,
      "nacelle_rotation": -0.25,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.11,
      "pylon_engineeringForeOffset": 0.15,
      "pylon_engineeringAftOffset": 0.11,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.69,
      "pylon_thickness": 0.33,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 9.62,
      "nacelleLower_x": 0.98,
      "nacelleLower_z": 1.24,
      "nacelleLower_length": 5.91,
      "nacelleLower_radius": 1.64,
      "nacelleLower_widthRatio": 0.41,
      "nacelleLower_rotation": -0.77,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.28,
      "pylonLower_nacelleAftOffset": 0.11,
      "pylonLower_engineeringForeOffset": 0.28,
      "pylonLower_engineeringAftOffset": 0.71,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 1.11,
      "pylonLower_thickness": 0.63,
      "name": "IKS Jeff'REES",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": -1.91,
      "nacelle_x": 4.3,
      "nacelle_z": 0.62,
      "nacelle_length": 9.8,
      "nacelle_radius": 0.84,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 13.95,
      "nacelleLower_x": 0.87,
      "nacelleLower_z": -1.22,
      "nacelleLower_length": 4.18,
      "nacelleLower_radius": 0.35,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -9.94,
      "engineering_z": 1.47,
      "engineering_length": 10.62,
      "engineering_radius": 0.7,
      "engineering_widthRatio": 3.71,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 0.66,
      "pylon_engineeringForeOffset": 0.12,
      "pylon_engineeringAftOffset": 0.18,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.1,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.05,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.03,
      "neck_primaryThickness": 0.03,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -2.21,
      "primary_z": 0.96,
      "primary_radius": 4.56,
      "primary_thickness": 1.74,
      "primary_widthRatio": 0.88,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "RSI Cloaked Canary"
    },
    {
      "name": "McQuarrie Fever",
      "nacelle_toggle": true,
      "nacelle_y": 26.19,
      "nacelle_x": 5.94,
      "nacelle_z": -7.83,
      "nacelle_length": 35.42,
      "nacelle_radius": 0.86,
      "nacelle_widthRatio": 1.97,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "boomLower_toggle": false,
      "engineering_toggle": true,
      "engineering_y": -37.28,
      "engineering_z": 6.5,
      "engineering_length": 26.93,
      "engineering_radius": 1.49,
      "engineering_widthRatio": 1.6,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.31,
      "pylon_nacelleAftOffset": 0.6,
      "pylon_engineeringForeOffset": 0.04,
      "pylon_engineeringAftOffset": 0.18,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.1,
      "neck_engineeringAftOffset": 0.13,
      "neck_thickness": 1.17,
      "neck_primaryThickness": 1.17,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -2.14,
      "primary_z": 1.58,
      "primary_radius": 13.06,
      "primary_thickness": 3.36,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
    },
    {
      "primary_toggle": true,
      "primary_y": -23.57,
      "primary_z": -0.08,
      "primary_radius": 10.71,
      "primary_thickness": 4.34,
      "primary_widthRatio": 0.88,
      "primary_pointiness": 0.01,
      "primary_bridgeThickness": 1.33,
      "primary_bridgeRadius": 0.31,
      "primary_bridgeWidthRatio": 1.05,
      "primary_bridgeZ": 0.18,
      "primary_bridgeY": 0.09,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 0.3,
      "neck_thickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -35.86,
      "engineering_z": 2.27,
      "engineering_length": 26.92,
      "engineering_radius": 1.89,
      "engineering_widthRatio": 2.57,
      "engineering_skew": -2.02,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 18.15,
      "nacelle_x": 4.75,
      "nacelle_z": -3.32,
      "nacelle_length": 12.64,
      "nacelle_radius": 1.58,
      "nacelle_widthRatio": 2.39,
      "nacelle_rotation": -0.46,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 0.33,
      "pylon_engineeringForeOffset": 0.56,
      "pylon_engineeringAftOffset": 0.04,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.34,
      "pylon_thickness": 0.47,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 19.12,
      "nacelleLower_x": 1.26,
      "nacelleLower_z": 1.63,
      "nacelleLower_length": 18.04,
      "nacelleLower_radius": 2.22,
      "nacelleLower_widthRatio": 0.29,
      "nacelleLower_rotation": -1.57,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.03,
      "name": "Insolent",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 10.2,
      "nacelle_x": 5.47,
      "nacelle_z": -6.64,
      "nacelle_length": 28.62,
      "nacelle_radius": 1.71,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "boomLower_toggle": false,
      "engineering_toggle": true,
      "engineering_y": -27.53,
      "engineering_z": -2.08,
      "engineering_length": 12.56,
      "engineering_radius": 2.2,
      "engineering_widthRatio": 2.37,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 1,
      "pylon_nacelleAftOffset": 0.45,
      "pylon_engineeringForeOffset": 0.21,
      "pylon_engineeringAftOffset": 0.86,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.12,
      "neck_primaryAftOffset": 0.18,
      "neck_engineeringForeOffset": 0.62,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.3,
      "neck_primaryThickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -10,
      "primary_z": 0.5,
      "primary_radius": 14.81,
      "primary_thickness": 4,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": 'USS Gloucester',
    },
    {
      "primary_toggle": true,
      "primary_y": -2.19,
      "primary_z": -1.55,
      "primary_radius": 13.06,
      "primary_thickness": 4.68,
      "primary_widthRatio": 1,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.63,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.38,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0.29,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.3,
      "neck_primaryThickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -21.38,
      "engineering_z": 0.53,
      "engineering_length": 25.3,
      "engineering_radius": 3.17,
      "engineering_widthRatio": 0.59,
      "engineering_skew": 0.05,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 19.8,
      "nacelle_x": 4.94,
      "nacelle_z": 3.4,
      "nacelle_length": 18.77,
      "nacelle_radius": 0.86,
      "nacelle_widthRatio": 2.47,
      "nacelle_rotation": -0.94,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.19,
      "pylon_nacelleAftOffset": 0.5,
      "pylon_engineeringForeOffset": 0.44,
      "pylon_engineeringAftOffset": 0.15,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.57,
      "pylon_thickness": 0.63,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 19.26,
      "nacelleLower_x": 4.94,
      "nacelleLower_z": 6.25,
      "nacelleLower_length": 18.44,
      "nacelleLower_radius": 0.86,
      "nacelleLower_widthRatio": 2.47,
      "nacelleLower_rotation": 0.94,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.2,
      "pylonLower_nacelleAftOffset": 0.49,
      "pylonLower_engineeringForeOffset": 0.45,
      "pylonLower_engineeringAftOffset": 0.17,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.6,
      "pylonLower_thickness": 0.45,
      "boomLower_toggle": false,
      "name": "Smallstepper",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 10.12,
      "nacelle_x": 2.6,
      "nacelle_z": -2.06,
      "nacelle_length": 14.34,
      "nacelle_radius": 0.85,
      "nacelle_widthRatio": 2.47,
      "nacelle_rotation": -0.19,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 10.11,
      "nacelleLower_x": 2.63,
      "nacelleLower_z": 2.08,
      "nacelleLower_length": 9.7,
      "nacelleLower_radius": 1.16,
      "nacelleLower_widthRatio": 1.18,
      "nacelleLower_rotation": 0.53,
      "engineering_toggle": true,
      "engineering_y": -12.04,
      "engineering_z": 0.09,
      "engineering_length": 13.31,
      "engineering_radius": 2.19,
      "engineering_widthRatio": 0.59,
      "engineering_skew": -0.84,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.38,
      "pylon_nacelleAftOffset": 0,
      "pylon_engineeringForeOffset": 0.39,
      "pylon_engineeringAftOffset": 0.31,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.24,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.52,
      "pylonLower_nacelleAftOffset": 0.19,
      "pylonLower_engineeringForeOffset": 0.48,
      "pylonLower_engineeringAftOffset": 0.02,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.04,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.16,
      "neck_primaryThickness": 0.16,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -1.15,
      "primary_z": -0.8,
      "primary_radius": 9.11,
      "primary_thickness": 2.46,
      "primary_widthRatio": 0.83,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Pfiel",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": 1.57,
      "primary_z": -4.85,
      "primary_radius": 20.59,
      "primary_thickness": 5.27,
      "primary_widthRatio": 0.62,
      "primary_pointiness": 0.36,
      "primary_bridgeThickness": 0.94,
      "primary_bridgeRadius": 0.63,
      "primary_bridgeWidthRatio": 0.51,
      "primary_bridgeZ": -0.55,
      "primary_bridgeY": -0.02,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.7,
      "neck_primaryAftOffset": 0.02,
      "neck_engineeringForeOffset": 0.75,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 1.05,
      "neck_thickness": 0.9,
      "neck_foretaper": 0.08,
      "neck_afttaper": 0.32,
      "engineering_toggle": true,
      "engineering_y": -22.91,
      "engineering_z": 2.52,
      "engineering_length": 15.65,
      "engineering_radius": 2.96,
      "engineering_widthRatio": 0.98,
      "engineering_skew": -0.65,
      "engineering_undercut": 0.56,
      "engineering_undercutStart": 0.02,
      "engineering_undercutCurve": 3.33,
      "engineering_dishRadius": 0.95,
      "engineering_dishInset": 0.14,
      "nacelle_toggle": true,
      "nacelle_y": 5.15,
      "nacelle_x": 0,
      "nacelle_z": -7.55,
      "nacelle_length": 35.17,
      "nacelle_radius": 2.04,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0.41,
      "nacelle_undercut": 1,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.03,
      "pylon_nacelleAftOffset": 0.88,
      "pylon_engineeringForeOffset": 0.29,
      "pylon_engineeringAftOffset": 0.13,
      "pylon_engineeringZOffset": 0.24,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.35,
      "nacelleLower_toggle": false,
      "nacelleLower_y": -6.96,
      "nacelleLower_x": 3.14,
      "nacelleLower_z": -2.48,
      "nacelleLower_length": 14.31,
      "nacelleLower_radius": 1.25,
      "nacelleLower_widthRatio": 0.91,
      "nacelleLower_rotation": -0.06,
      "nacelleLower_undercutStart": 0.04,
      "nacelleLower_undercut": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.17,
      "pylonLower_nacelleAftOffset": 0.12,
      "pylonLower_engineeringForeOffset": 0.85,
      "pylonLower_engineeringAftOffset": -0.07,
      "pylonLower_engineeringZOffset": 3.91,
      "pylonLower_midPointOffset": 0.61,
      "pylonLower_thickness": 0.22,
      "name": "USS Freja",
      "nacelle_lowerToggle": false,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "primary_segments": 64,
      "primary_bridgeSegments": 64
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 15.89,
      "nacelle_x": 3.87,
      "nacelle_z": -0.47,
      "nacelle_length": 13.37,
      "nacelle_radius": 0.8,
      "nacelle_widthRatio": 1.88,
      "nacelle_rotation": -0.31,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 18.72,
      "nacelleLower_x": 6.44,
      "nacelleLower_z": 2.33,
      "nacelleLower_length": 5.97,
      "nacelleLower_radius": 0.66,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -22.35,
      "engineering_z": -0.19,
      "engineering_length": 23.18,
      "engineering_radius": 1.34,
      "engineering_widthRatio": 0.58,
      "engineering_skew": -2,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.2,
      "pylon_nacelleAftOffset": 0.45,
      "pylon_engineeringForeOffset": 0.3,
      "pylon_engineeringAftOffset": 0.19,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.38,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.53,
      "pylonLower_nacelleAftOffset": 0.09,
      "pylonLower_engineeringForeOffset": 0.52,
      "pylonLower_engineeringAftOffset": 0.08,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.07,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.31,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.17,
      "neck_primaryThickness": 0.17,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -3.8,
      "primary_z": -4.15,
      "primary_radius": 11.62,
      "primary_thickness": 3.35,
      "primary_widthRatio": 0.09,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "FinchFodder Class",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": false,
      "nacelle_y": -1.58,
      "nacelle_x": 6.06,
      "nacelle_z": -1.32,
      "nacelle_length": 18.16,
      "nacelle_radius": 0.5,
      "nacelle_widthRatio": 1.88,
      "nacelle_rotation": -0.38,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 7.24,
      "nacelleLower_x": 2.33,
      "nacelleLower_z": -1.37,
      "nacelleLower_length": 12.4,
      "nacelleLower_radius": 1.58,
      "nacelleLower_widthRatio": 0.39,
      "nacelleLower_rotation": -0.38,
      "engineering_toggle": true,
      "engineering_y": -14.08,
      "engineering_z": -1.98,
      "engineering_length": 8.89,
      "engineering_radius": 1.01,
      "engineering_widthRatio": 2.04,
      "engineering_skew": 2.02,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.65,
      "pylon_engineeringForeOffset": 0.37,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,    
      "pylon_thickness": 0.21,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.69,
      "pylonLower_nacelleAftOffset": 0.19,
      "pylonLower_engineeringForeOffset": 0.44,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_thickness": 0.07,
      "boomLower_toggle": false,
      "pylonLower_midPointOffset": 0.1,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.17,
      "neck_primaryThickness": 0.17,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -3.42,
      "primary_z": -3.73,
      "primary_radius": 6.74,
      "primary_thickness": 3.02,
      "primary_widthRatio": 0.09,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Sweepenflieger Class",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -1.11,
      "primary_z": 0.19,
      "primary_radius": 3.97,
      "primary_thickness": 2.81,
      "primary_widthRatio": 1.59,
      "primary_pointiness": 0.42,
      "primary_bridgeThickness": 1.28,
      "primary_bridgeRadius": 1.2,
      "primary_bridgeWidthRatio": 0.33,
      "primary_bridgeZ": 0.13,
      "primary_bridgeY": -0.05,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.09,
      "neck_thickness": 0.09,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -13.41,
      "engineering_z": 2.22,
      "engineering_length": 10.04,
      "engineering_radius": 2.1,
      "engineering_widthRatio": 1.43,
      "engineering_skew": -0.91,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 0.19,
      "nacelle_x": 4.62,
      "nacelle_z": -2.2,
      "nacelle_length": 13.21,
      "nacelle_radius": 0.69,
      "nacelle_widthRatio": 2.11,
      "nacelle_rotation": -0.8,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 0.74,
      "pylon_engineeringForeOffset": 0.3,
      "pylon_engineeringAftOffset": 0.39,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.32,
      "pylon_thickness": 0.26,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 11.03,
      "nacelleLower_x": 4.39,
      "nacelleLower_z": 1.81,
      "nacelleLower_length": 3.33,
      "nacelleLower_radius": 1.09,
      "nacelleLower_widthRatio": 0.4,
      "nacelleLower_rotation": 0.81,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.27,
      "pylonLower_nacelleAftOffset": 0.09,
      "pylonLower_engineeringForeOffset": 0.52,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.04,
      "name": "RightStuff",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -9.22,
      "primary_z": 2.74,
      "primary_radius": 10.71,
      "primary_thickness": 3.85,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.86,
      "primary_bridgeThickness": 1.16,
      "primary_bridgeRadius": 1.2,
      "primary_bridgeWidthRatio": 0.46,
      "primary_bridgeZ": 0.06,
      "primary_bridgeY": -0.43,
      "primary_notchAngle": 0.18,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.68,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.36,
      "neck_thickness": 0.36,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -31.29,
      "engineering_z": 8.53,
      "engineering_length": 13.27,
      "engineering_radius": 2.08,
      "engineering_widthRatio": 1.26,
      "engineering_skew": -1.55,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.09,
      "engineering_undercutCurve": 6.64,
      "engineering_dishRadius": 0.95,
      "engineering_dishInset": 0.4,
      "nacelle_toggle": true,
      "nacelle_y": 17.66,
      "nacelle_x": 3.57,
      "nacelle_z": -2.34,
      "nacelle_length": 22.68,
      "nacelle_radius": 1.61,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.51,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.18,
      "pylon_nacelleAftOffset": 0.74,
      "pylon_engineeringForeOffset": 0.63,
      "pylon_engineeringAftOffset": 0.04,
      "pylon_engineeringZOffset": -0.1,
      "pylon_midPointOffset": 0.33,
      "pylon_thickness": 0.15,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 5.92,
      "nacelleLower_x": 1.62,
      "nacelleLower_z": 4.34,
      "nacelleLower_length": 15.17,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "nacelleLower_undercutStart": 0.29,
      "nacelleLower_undercut": 0.8,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.18,
      "pylonLower_nacelleAftOffset": 0.19,
      "pylonLower_engineeringForeOffset": 0.31,
      "pylonLower_engineeringAftOffset": 0.03,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.25,
      "name": "Turnkey II",
      "nacelle_lowerToggle": false,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "primary_segments": 3,
      "primary_bridgeSegments": 3
    },
    {
      "primary_toggle": true,
      "primary_y": -5.31,
      "primary_z": 1.14,
      "primary_radius": 13.82,
      "primary_thickness": 4.99,
      "primary_widthRatio": 0.74,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 0.9,
      "primary_bridgeRadius": 0.36,
      "primary_bridgeWidthRatio": 0.66,
      "primary_bridgeZ": 0.26,
      "primary_bridgeY": 0.21,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.52,
      "neck_primaryAftOffset": 0.05,
      "neck_engineeringForeOffset": 0.11,
      "neck_engineeringAftOffset": 0.24,
      "neck_primaryThickness": 5,
      "neck_thickness": 3.73,
      "neck_foretaper": 0.01,
      "neck_afttaper": 0.34,
      "engineering_toggle": true,
      "engineering_y": -35.7,
      "engineering_z": 7.81,
      "engineering_length": 26.73,
      "engineering_radius": 2.84,
      "engineering_widthRatio": 1.02,
      "engineering_skew": -0.83,
      "engineering_undercut": 1,
      "engineering_undercutStart": 0.29,
      "engineering_undercutCurve": 6.64,
      "engineering_dishRadius": 0.85,
      "engineering_dishInset": 0.2,
      "nacelle_toggle": true,
      "nacelle_y": 22.34,
      "nacelle_x": 3.4,
      "nacelle_z": -1.86,
      "nacelle_length": 26.98,
      "nacelle_radius": 1.73,
      "nacelle_widthRatio": 0.57,
      "nacelle_rotation": -0.11,
      "nacelle_undercutStart": 0,
      "nacelle_undercut": 0.51,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": -0.07,
      "pylon_nacelleAftOffset": 0.81,
      "pylon_engineeringForeOffset": 0.67,
      "pylon_engineeringAftOffset": 0.19,
      "pylon_engineeringZOffset": -1.24,
      "pylon_midPointOffset": 0.86,
      "pylon_thickness": 0.29,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 18.74,
      "nacelleLower_x": 0.58,
      "nacelleLower_z": 7.05,
      "nacelleLower_length": 11.66,
      "nacelleLower_radius": 3.27,
      "nacelleLower_widthRatio": 0.38,
      "nacelleLower_rotation": 1.54,
      "nacelleLower_undercutStart": 0,
      "nacelleLower_undercut": 1,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.48,
      "pylonLower_engineeringForeOffset": 0,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0,
      "pylonLower_midPointOffset": 0.34,
      "pylonLower_thickness": 0.01,
      "name": "Chezzetcook Bay",
      "nacelle_lowerToggle": false,
      "nacelle_skew": 0,
      "nacelleLower_segments": 32,
      "nacelleLower_skew": 0,
      "primary_segments": 64,
      "primary_bridgeSegments": 64
    },
    {
      "primary_toggle": true,
      "primary_y": 0.73,
      "primary_z": 4.19,
      "primary_radius": 24.54,
      "primary_thickness": 13.08,
      "primary_widthRatio": 0.65,
      "primary_pointiness": 0.46,
      "primary_bridgeThickness": 0.94,
      "primary_bridgeRadius": 1.2,
      "primary_bridgeWidthRatio": 0.5,
      "primary_bridgeZ": -0.1,
      "primary_bridgeY": 0.08,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.19,
      "neck_primaryAftOffset": 0.11,
      "neck_engineeringForeOffset": 0.42,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 2.94,
      "neck_thickness": 0.66,
      "neck_foretaper": 0.88,
      "neck_afttaper": 0.56,
      "engineering_toggle": true,
      "engineering_y": -34.09,
      "engineering_z": 12.33,
      "engineering_length": 40.12,
      "engineering_radius": 8.05,
      "engineering_widthRatio": 0.52,
      "engineering_skew": -0.45,
      "engineering_undercut": 0.7,
      "engineering_undercutStart": 0.33,
      "engineering_undercutCurve": 4.07,
      "engineering_dishRadius": 0.97,
      "engineering_dishInset": 0.41,
      "nacelle_toggle": false,
      "nacelle_y": -20,
      "nacelle_x": 11.85,
      "nacelle_z": -15,
      "nacelle_length": 44.07,
      "nacelle_radius": 2.71,
      "nacelle_widthRatio": 0.95,
      "nacelle_rotation": -0.01,
      "nacelle_undercutStart": 0.1,
      "nacelle_undercut": 0.41,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.39,
      "pylon_nacelleAftOffset": 0.38,
      "pylon_engineeringForeOffset": 0.17,
      "pylon_engineeringAftOffset": 0.72,
      "pylon_engineeringZOffset": 5.19,
      "pylon_midPointOffset": 0.44,
      "pylon_thickness": 0.34,
      "nacelleLower_toggle": true,
      "nacelleLower_y": -20,
      "nacelleLower_x": 12.03,
      "nacelleLower_z": 15,
      "nacelleLower_length": 32.7,
      "nacelleLower_radius": 2.6,
      "nacelleLower_widthRatio": 0.85,
      "nacelleLower_rotation": -0.17,
      "nacelleLower_undercutStart": 0,
      "nacelleLower_undercut": 0.66,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.32,
      "pylonLower_nacelleAftOffset": 0.17,
      "pylonLower_engineeringForeOffset": 0.73,
      "pylonLower_engineeringAftOffset": 0.13,
      "pylonLower_engineeringZOffset": -3.87,
      "pylonLower_midPointOffset": 0.59,
      "pylonLower_thickness": 0.38,
      "name": "USS CROMULENT",
      "nacelle_lowerToggle": false,
      "primary_segments": null,
      "primary_bridgeSegments": null,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 0.19,
      "nacelle_x": 2.37,
      "nacelle_z": -1.21,
      "nacelle_length": 11.91,
      "nacelle_radius": 0.86,
      "nacelle_widthRatio": 1.64,
      "nacelle_rotation": -0.49,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 6.03,
      "nacelleLower_x": 1.57,
      "nacelleLower_z": 1.24,
      "nacelleLower_length": 5.79,
      "nacelleLower_radius": 0.69,
      "nacelleLower_widthRatio": 1.18,
      "nacelleLower_rotation": 0.31,
      "engineering_toggle": true,
      "engineering_y": -13.87,
      "engineering_z": 3.42,
      "engineering_length": 5.1,
      "engineering_radius": 1.09,
      "engineering_widthRatio": 1.84,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.6,
      "pylon_nacelleAftOffset": 0.08,
      "pylon_engineeringForeOffset": 0.16,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,    
      "pylon_thickness": 0.22,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.53,
      "pylonLower_nacelleAftOffset": 0.09,
      "pylonLower_engineeringForeOffset": 0.52,
      "pylonLower_engineeringAftOffset": 0.08,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.04,
      "boomLower_toggle": false,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.09,
      "neck_primaryThickness": 0.09,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 0.6,
      "primary_z": 0.5,
      "primary_radius": 6.3,
      "primary_thickness": 2.44,
      "primary_widthRatio": 1.16,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "TeaKettleSprinter",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 9.5,
      "nacelle_x": 0,
      "nacelle_z": 4.53,
      "nacelle_length": 14.85,
      "nacelle_radius": 0.93,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 9.69,
      "nacelleLower_x": 2.63,
      "nacelleLower_z": 4.11,
      "nacelleLower_length": 14.74,
      "nacelleLower_radius": 0.91,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -16.62,
      "engineering_z": 0.67,
      "engineering_length": 10.3,
      "engineering_radius": 1.29,
      "engineering_widthRatio": 1,
      "engineering_skew": 1.16,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.64,
      "pylon_nacelleAftOffset": 0.11,
      "pylon_engineeringForeOffset": 0.5,
      "pylon_engineeringAftOffset": 0.24,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.76,
      "pylonLower_nacelleAftOffset": 0.13,
      "pylonLower_engineeringForeOffset": 0.28,
      "pylonLower_engineeringAftOffset": 0.19,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.25,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.29,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.42,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.35,
      "neck_primaryThickness": 0.35,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -1.74,
      "primary_z": -3.19,
      "primary_radius": 9.74,
      "primary_thickness": 3.49,
      "primary_widthRatio": 0.29,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Mark III",
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": -0.91,
      "nacelle_x": 4.78,
      "nacelle_z": -0.63,
      "nacelle_length": 14.29,
      "nacelle_radius": 0.98,
      "nacelle_widthRatio": 2.11,
      "nacelle_rotation": -0.26,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 14.57,
      "nacelleLower_x": 2.39,
      "nacelleLower_z": -4.12,
      "nacelleLower_length": 8.82,
      "nacelleLower_radius": 1.05,
      "nacelleLower_widthRatio": 1.18,
      "nacelleLower_rotation": 0.48,
      "engineering_toggle": true,
      "engineering_y": -17.83,
      "engineering_z": -2.26,
      "engineering_length": 11.63,
      "engineering_radius": 1.76,
      "engineering_widthRatio": 1.71,
      "engineering_skew": -0.37,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 0.71,
      "pylon_engineeringForeOffset": 0.34,
      "pylon_engineeringAftOffset": 0.2,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.54,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.36,
      "pylonLower_nacelleAftOffset": 0.44,
      "pylonLower_engineeringForeOffset": 0.2,
      "pylonLower_engineeringAftOffset": 0.39,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.27,
      "boomLower_toggle": false,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.14,
      "neck_primaryThickness": 0.14,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -0.22,
      "primary_z": -0.73,
      "primary_radius": 7.63,
      "primary_thickness": 3.1,
      "primary_widthRatio": 1.56,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Prosperous",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": false,
      "nacelle_y": 22.08,
      "nacelle_x": -0.01,
      "nacelle_z": -11.6,
      "nacelle_length": 7.51,
      "nacelle_radius": 0.61,
      "nacelle_widthRatio": 1.88,
      "nacelle_rotation": -0.45,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 8.77,
      "nacelleLower_x": 2.85,
      "nacelleLower_z": -4.85,
      "nacelleLower_length": 15.1,
      "nacelleLower_radius": 1.91,
      "nacelleLower_widthRatio": 0.39,
      "nacelleLower_rotation": -0.43,
      "engineering_toggle": true,
      "engineering_y": -17.12,
      "engineering_z": 1.17,
      "engineering_length": 10.81,
      "engineering_radius": 1.24,
      "engineering_widthRatio": 2.04,
      "engineering_skew": -1.64,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.26,
      "pylon_nacelleAftOffset": 0.08,
      "pylon_engineeringForeOffset": 0.26,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,    
      "pylon_thickness": 0.17,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.48,
      "pylonLower_nacelleAftOffset": 0.04,
      "pylonLower_engineeringForeOffset": 0.26,
      "pylonLower_engineeringAftOffset": 0.16,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.34,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.2,
      "neck_primaryThickness": 0.2,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -4.15,
      "primary_z": -3.1,
      "primary_radius": 10.47,
      "primary_thickness": 3.11,
      "primary_widthRatio": 0.56,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "VSA Mol-Kom",
      "nacelle_lowerToggle": false,
    },
    {
      "primary_toggle": true,
      "primary_y": -5.71,
      "primary_z": -4.32,
      "primary_radius": 6.48,
      "primary_thickness": 4.7,
      "primary_widthRatio": 0.96,
      "primary_pointiness": 0.71,
      "primary_bridgeThickness": 0.9,
      "primary_bridgeRadius": 1.17,
      "primary_bridgeWidthRatio": 0.35,
      "primary_bridgeZ": -0.37,
      "primary_bridgeY": -0.44,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.59,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 5,
      "neck_thickness": 0.18,
      "neck_foretaper": 0.01,
      "neck_afttaper": 0.34,
      "engineering_toggle": true,
      "engineering_y": -15.41,
      "engineering_z": 2.73,
      "engineering_length": 11.54,
      "engineering_radius": 3.32,
      "engineering_widthRatio": 0.21,
      "engineering_skew": -0.95,
      "engineering_undercut": 0.8,
      "engineering_undercutStart": 0.18,
      "engineering_undercutCurve": 5.65,
      "engineering_dishRadius": 0.94,
      "engineering_dishInset": 0.33,
      "nacelle_toggle": false,
      "nacelle_y": 15.56,
      "nacelle_x": 0,
      "nacelle_z": -13.46,
      "nacelle_length": 6.76,
      "nacelle_radius": 0.55,
      "nacelle_widthRatio": 1.88,
      "nacelle_rotation": -0.45,
      "nacelle_undercutStart": 0.98,
      "nacelle_undercut": 0.75,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": -0.1,
      "pylon_nacelleAftOffset": 0.48,
      "pylon_engineeringForeOffset": 0.3,
      "pylon_engineeringAftOffset": 0.21,
      "pylon_engineeringZOffset": -0.06,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.27,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 6,
      "nacelleLower_x": 3.76,
      "nacelleLower_z": 1.94,
      "nacelleLower_length": 13.95,
      "nacelleLower_radius": 1.19,
      "nacelleLower_widthRatio": 0.98,
      "nacelleLower_rotation": 0.02,
      "nacelleLower_undercutStart": 0.42,
      "nacelleLower_undercut": 0.76,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.67,
      "pylonLower_nacelleAftOffset": 0.04,
      "pylonLower_engineeringForeOffset": 0.34,
      "pylonLower_engineeringAftOffset": 0.16,
      "pylonLower_engineeringZOffset": -2,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.17,
      "name": "birkenshöl",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null,
      "primary_segments": null,
      "primary_bridgeSegments": null
    },
    {
      "primary_toggle": true,
      "primary_y": -4.63,
      "primary_z": -4.05,
      "primary_radius": 9.11,
      "primary_thickness": 3.04,
      "primary_widthRatio": 1.02,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.12,
      "primary_bridgeRadius": 0.36,
      "primary_bridgeWidthRatio": 0.62,
      "primary_bridgeZ": 0.1,
      "primary_bridgeY": -0.33,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.62,
      "neck_primaryAftOffset": 0.07,
      "neck_engineeringForeOffset": 0.11,
      "neck_engineeringAftOffset": 0.22,
      "neck_primaryThickness": 0.55,
      "neck_thickness": 0.55,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -14.39,
      "engineering_z": 3.09,
      "engineering_length": 10.23,
      "engineering_radius": 2.12,
      "engineering_widthRatio": 0.65,
      "engineering_skew": -0.21,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": false,
      "nacelle_y": 7.68,
      "nacelle_x": 0,
      "nacelle_z": -12.46,
      "nacelle_length": 5.47,
      "nacelle_radius": 0.44,
      "nacelle_widthRatio": 1.88,
      "nacelle_rotation": -0.42,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.28,
      "pylon_nacelleAftOffset": 0.02,
      "pylon_engineeringForeOffset": 0.14,
      "pylon_engineeringAftOffset": 0.22,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 6.39,
      "nacelleLower_x": 3.43,
      "nacelleLower_z": 3.26,
      "nacelleLower_length": 12.41,
      "nacelleLower_radius": 1.96,
      "nacelleLower_widthRatio": 0.39,
      "nacelleLower_rotation": 0,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.19,
      "pylonLower_nacelleAftOffset": 0.49,
      "pylonLower_engineeringForeOffset": 0.15,
      "pylonLower_engineeringAftOffset": 0.62,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.32,
      "name": "SwingLowSweet",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 4.72,
      "nacelle_x": 1.69,
      "nacelle_z": -1.65,
      "nacelle_length": 15.54,
      "nacelle_radius": 0.48,
      "nacelle_widthRatio": 2.5,
      "nacelle_rotation": 0.39,
      "nacelleLower_toggle": false,
      "nacelleLower_y": -5.77,
      "nacelleLower_x": -1.27,
      "nacelleLower_z": -2.36,
      "nacelleLower_length": 8.73,
      "nacelleLower_radius": 0.26,
      "nacelleLower_widthRatio": 2.47,
      "nacelleLower_rotation": 0.01,
      "engineering_toggle": true,
      "engineering_y": -11.22,
      "engineering_z": 0.23,
      "engineering_length": 11.98,
      "engineering_radius": 1.25,
      "engineering_widthRatio": 0.52,
      "engineering_skew": -0.51,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.03,
      "pylon_nacelleAftOffset": 0.85,
      "pylon_engineeringForeOffset": 0.11,
      "pylon_engineeringAftOffset": 0.05,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.17,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.47,
      "pylonLower_nacelleAftOffset": 0,
      "pylonLower_engineeringForeOffset": 0.53,
      "pylonLower_engineeringAftOffset": 0.16,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.14,
      "boomLower_toggle": false,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.32,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.43,
      "neck_engineeringAftOffset": 0.1,
      "neck_thickness": 0.31,
      "neck_primaryThickness": 0.31,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 3.53,
      "primary_z": -3.02,
      "primary_radius": 8.13,
      "primary_thickness": 2.05,
      "primary_widthRatio": 0.58,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Autumns Crispy Embrace",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 10.2,
      "nacelle_x": 5.47,
      "nacelle_z": -6.64,
      "nacelle_length": 28.62,
      "nacelle_radius": 2.28,
      "nacelle_widthRatio": 0.46,
      "nacelle_rotation": 0.76,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 10.2,
      "nacelleLower_x": 5.47,
      "nacelleLower_z": 6.68,
      "nacelleLower_length": 18.44,
      "nacelleLower_radius": 0.55,
      "nacelleLower_widthRatio": 2.77,
      "nacelleLower_rotation": 0.53,
      "engineering_toggle": true,
      "engineering_y": -27.53,
      "engineering_z": 3.8,
      "engineering_length": 23.99,
      "engineering_radius": 3.69,
      "engineering_widthRatio": 0.65,
      "engineering_skew": -0.97,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 1,
      "pylon_nacelleAftOffset": 0.5,
      "pylon_engineeringForeOffset": 0.81,
      "pylon_engineeringAftOffset": 0.44,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.96,
      "pylonLower_nacelleAftOffset": 0,
      "pylonLower_engineeringForeOffset": 0.56,
      "pylonLower_engineeringAftOffset": 0.27,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.92,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.12,
      "neck_primaryAftOffset": 0.18,
      "neck_engineeringForeOffset": 0.62,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.3,
      "neck_primaryThickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -6.33,
      "primary_z": 0.5,
      "primary_radius": 18.47,
      "primary_thickness": 4.26,
      "primary_widthRatio": 0.49,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Bonaventure",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -6.33,
      "primary_z": 0.5,
      "primary_radius": 18.47,
      "primary_thickness": 4.26,
      "primary_widthRatio": 0.49,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.03,
      "primary_bridgeRadius": 0.41,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.16,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.12,
      "neck_primaryAftOffset": 0.18,
      "neck_engineeringForeOffset": 0.62,
      "neck_engineeringAftOffset": 0.08,
      "neck_primaryThickness": 0.3,
      "neck_thickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -27.53,
      "engineering_z": 3.8,
      "engineering_length": 23.99,
      "engineering_radius": 4.5,
      "engineering_widthRatio": 0.46,
      "engineering_skew": -0.97,
      "engineering_undercut": 0.63,
      "engineering_undercutStart": 0.17,
      "engineering_undercutCurve": 6.72,
      "engineering_dishRadius": 0.83,
      "engineering_dishInset": 1.3,
      "nacelle_toggle": true,
      "nacelle_y": 10.2,
      "nacelle_x": 5.47,
      "nacelle_z": -6.64,
      "nacelle_length": 28.62,
      "nacelle_radius": 2.28,
      "nacelle_widthRatio": 0.46,
      "nacelle_rotation": 0.76,
      "nacelle_undercutStart": 0.9,
      "nacelle_undercut": 0.75,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 1,
      "pylon_nacelleAftOffset": 0.5,
      "pylon_engineeringForeOffset": 0.81,
      "pylon_engineeringAftOffset": 0.44,
      "pylon_engineeringZOffset": 0,
      "pylon_midPointOffset": 0.12,
      "pylon_thickness": 0.3,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 16.02,
      "nacelleLower_x": 5.39,
      "nacelleLower_z": 6.68,
      "nacelleLower_length": 13.66,
      "nacelleLower_radius": 2.31,
      "nacelleLower_widthRatio": 0.2,
      "nacelleLower_rotation": 2.23,
      "nacelleLower_undercutStart": 0.04,
      "nacelleLower_undercut": 0.76,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.96,
      "pylonLower_nacelleAftOffset": 0,
      "pylonLower_engineeringForeOffset": 0.47,
      "pylonLower_engineeringAftOffset": 0.27,
      "pylonLower_engineeringZOffset": -2.01,
      "pylonLower_midPointOffset": 0.4,
      "pylonLower_thickness": 0.31,
      "name": "BJORN BJORNANSEN",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": -2.49,
      "nacelle_x": 2.2,
      "nacelle_z": 0.18,
      "nacelle_length": 15.69,
      "nacelle_radius": 1.04,
      "nacelle_widthRatio": 0.59,
      "nacelle_rotation": 0.26,
      "nacelleLower_toggle": true,
      "nacelleLower_y": -2.49,
      "nacelleLower_x": 2.2,
      "nacelleLower_z": 1.61,
      "nacelleLower_length": 15.69,
      "nacelleLower_radius": 1.01,
      "nacelleLower_widthRatio": 0.59,
      "nacelleLower_rotation": -0.24,
      "engineering_toggle": true,
      "engineering_y": -16.47,
      "engineering_z": 3.87,
      "engineering_length": 8.96,
      "engineering_radius": 1.26,
      "engineering_widthRatio": 0.98,
      "engineering_skew": -0.71,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 0.54,
      "pylon_engineeringForeOffset": 0.4,
      "pylon_engineeringAftOffset": 0.19,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.21,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.53,
      "pylonLower_nacelleAftOffset": 0.09,
      "pylonLower_engineeringForeOffset": 0.52,
      "pylonLower_engineeringAftOffset": 0.08,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.04,
      "boomLower_toggle": false,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.45,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.09,
      "neck_primaryThickness": 0.09,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 1.86,
      "primary_z": -0.83,
      "primary_radius": 6.83,
      "primary_thickness": 2.9,
      "primary_widthRatio": 0.96,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Dutchess of Spam",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 4.39,
      "nacelle_x": 2.35,
      "nacelle_z": -2.49,
      "nacelle_length": 12.32,
      "nacelle_radius": 1.35,
      "nacelle_widthRatio": 0.32,
      "nacelle_rotation": -0.37,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 3.7,
      "nacelleLower_x": 0.72,
      "nacelleLower_z": 0.49,
      "nacelleLower_length": 7.94,
      "nacelleLower_radius": 0.24,
      "nacelleLower_widthRatio": 2.96,
      "nacelleLower_rotation": 0.23,
      "engineering_toggle": true,
      "engineering_y": -11.85,
      "engineering_z": 1.64,
      "engineering_length": 10.33,
      "engineering_radius": 1.59,
      "engineering_widthRatio": 0.65,
      "engineering_skew": -0.97,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 1,
      "pylon_nacelleAftOffset": 0.5,
      "pylon_engineeringForeOffset": 0.81,
      "pylon_engineeringAftOffset": 0.44,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.13,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.34,
      "pylonLower_nacelleAftOffset": 0.32,
      "pylonLower_engineeringForeOffset": 0.16,
      "pylonLower_engineeringAftOffset": 0.07,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.09,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.12,
      "neck_primaryAftOffset": 0.18,
      "neck_engineeringForeOffset": 0.62,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.13,
      "neck_primaryThickness": 0.13,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 2.1,
      "primary_z": -2.04,
      "primary_radius": 8.03,
      "primary_thickness": 1.78,
      "primary_widthRatio": 0.69,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Hard-Driven Snowflake",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 17.13,
      "nacelle_x": 0,
      "nacelle_z": -2.06,
      "nacelle_length": 22.3,
      "nacelle_radius": 1.32,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 17.13,
      "nacelleLower_x": 0,
      "nacelleLower_z": 12.87,
      "nacelleLower_length": 22.31,
      "nacelleLower_radius": 1.33,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -29.29,
      "engineering_z": 7.61,
      "engineering_length": 17.46,
      "engineering_radius": 1.96,
      "engineering_widthRatio": 1,
      "engineering_skew": -1.24,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.03,
      "pylon_nacelleAftOffset": 0.84,
      "pylon_engineeringForeOffset": 0.61,
      "pylon_engineeringAftOffset": 0.04,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.88,
      "pylonLower_engineeringForeOffset": 0.6,
      "pylonLower_engineeringAftOffset": 0.02,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.29,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.26,
      "neck_primaryThickness": 0.26,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -14.32,
      "primary_z": 5.03,
      "primary_radius": 12,
      "primary_thickness": 2.76,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Orthoganis"
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 0.44,
      "nacelle_x": 3.16,
      "nacelle_z": 0.05,
      "nacelle_length": 13.68,
      "nacelle_radius": 1.83,
      "nacelle_widthRatio": 0.72,
      "nacelle_rotation": 1.14,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 7.44,
      "nacelleLower_x": -1.56,
      "nacelleLower_z": 2,
      "nacelleLower_length": 12.49,
      "nacelleLower_radius": 1.6,
      "nacelleLower_widthRatio": 1.18,
      "nacelleLower_rotation": 0.73,
      "engineering_toggle": true,
      "engineering_y": -20.77,
      "engineering_z": 3.99,
      "engineering_length": 16.53,
      "engineering_radius": 1.57,
      "engineering_widthRatio": 2.08,
      "engineering_skew": -0.84,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 1,
      "pylon_engineeringForeOffset": 0.13,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,    
      "pylon_thickness": 0.21,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.08,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.21,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_thickness": 0.19,
      "boomLower_toggle": false,
      "pylonLower_midPointOffset": 0.1,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.22,
      "neck_primaryThickness": 0.22,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 0.92,
      "primary_z": -1.58,
      "primary_radius": 10.61,
      "primary_thickness": 3.01,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Costa Brava",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -5.15,
      "primary_z": -2.3,
      "primary_radius": 9.01,
      "primary_thickness": 3.01,
      "primary_widthRatio": 0.11,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 0.77,
      "primary_bridgeRadius": 0.22,
      "primary_bridgeWidthRatio": 1.32,
      "primary_bridgeZ": 0.06,
      "primary_bridgeY": 0.14,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.03,
      "neck_thickness": 0.03,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -15.03,
      "engineering_z": -0.09,
      "engineering_length": 7.69,
      "engineering_radius": 2.04,
      "engineering_widthRatio": 0.72,
      "engineering_skew": -0.77,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 2.73,
      "nacelle_x": 3.86,
      "nacelle_z": 2.6,
      "nacelle_length": 10.92,
      "nacelle_radius": 0.19,
      "nacelle_widthRatio": 1.88,
      "nacelle_rotation": 0.47,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.52,
      "pylon_nacelleAftOffset": 0.19,
      "pylon_engineeringForeOffset": 0.48,
      "pylon_engineeringAftOffset": 0.02,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.01,
      "pylon_thickness": 0.22,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 2.73,
      "nacelleLower_x": 3.86,
      "nacelleLower_z": 3.11,
      "nacelleLower_length": 11.02,
      "nacelleLower_radius": 0.22,
      "nacelleLower_widthRatio": 1.78,
      "nacelleLower_rotation": 0.47,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.52,
      "pylonLower_nacelleAftOffset": 0.19,
      "pylonLower_engineeringForeOffset": 0.48,
      "pylonLower_engineeringAftOffset": 0.02,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.01,
      "pylonLower_thickness": 0.22,
      "name": "T-SixtyRedFiver Class",
      "nacelle_lowerToggle": false
    },
    {
      "primary_toggle": true,
      "primary_y": -9.67,
      "primary_z": 0.07,
      "primary_radius": 1.69,
      "primary_thickness": 2.48,
      "primary_widthRatio": 2.07,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 2.16,
      "primary_bridgeRadius": 0.52,
      "primary_bridgeWidthRatio": 0.43,
      "primary_bridgeZ": 0.8,
      "primary_bridgeY": 0.1,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.36,
      "neck_primaryAftOffset": 0.39,
      "neck_engineeringForeOffset": 0.17,
      "neck_engineeringAftOffset": 0.07,
      "neck_primaryThickness": 0.12,
      "neck_thickness": 0.12,
      "neck_foretaper": 0.66,
      "neck_afttaper": 0.66,
      "engineering_toggle": true,
      "engineering_y": -11.09,
      "engineering_z": 0.82,
      "engineering_length": 4.98,
      "engineering_radius": 2.36,
      "engineering_widthRatio": 1,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 4.32,
      "nacelle_x": 3.34,
      "nacelle_z": -1.25,
      "nacelle_length": 13.09,
      "nacelle_radius": 0.57,
      "nacelle_widthRatio": 2.09,
      "nacelle_rotation": -1.54,
      "pylon_toggle": false,
      "pylon_nacelleForeOffset": 0.42,
      "pylon_nacelleAftOffset": 0.08,
      "pylon_engineeringForeOffset": 0.36,
      "pylon_engineeringAftOffset": 0.13,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.06,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 6.98,
      "nacelleLower_x": 2.99,
      "nacelleLower_z": 1.02,
      "nacelleLower_length": 7.59,
      "nacelleLower_radius": 4.88,
      "nacelleLower_widthRatio": 0.1,
      "nacelleLower_rotation": 0,
      "boomLower_toggle": true,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.57,
      "pylonLower_engineeringForeOffset": 0.44,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.28,
      "pylonLower_thickness": 0.44,
      "name": "BatBlinder Class",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 4.13,
      "nacelle_x": 1.62,
      "nacelle_z": -1.04,
      "nacelle_length": 4.91,
      "nacelle_radius": 0.93,
      "nacelle_widthRatio": 0.52,
      "nacelle_rotation": -0.44,
      "nacelleLower_toggle": false,
      "nacelleLower_y": -3.11,
      "nacelleLower_x": 7.28,
      "nacelleLower_z": 2.91,
      "nacelleLower_length": 14.74,
      "nacelleLower_radius": 0.54,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -9.81,
      "engineering_z": 0.4,
      "engineering_length": 6.84,
      "engineering_radius": 0.53,
      "engineering_widthRatio": 3.69,
      "engineering_skew": 4.02,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.22,
      "pylon_nacelleAftOffset": 0.42,
      "pylon_engineeringForeOffset": 0.36,
      "pylon_engineeringAftOffset": 0.03,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.25,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.82,
      "pylonLower_nacelleAftOffset": 0.06,
      "pylonLower_engineeringForeOffset": 0,
      "pylonLower_engineeringAftOffset": 0.46,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.15,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.27,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.09,
      "neck_primaryThickness": 0.09,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -5.33,
      "primary_z": -0.76,
      "primary_radius": 4.75,
      "primary_thickness": 1.95,
      "primary_widthRatio": 0.19,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Northrop",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 7.71,
      "nacelle_x": -2.56,
      "nacelle_z": -1.75,
      "nacelle_length": 12.95,
      "nacelle_radius": 1.43,
      "nacelle_widthRatio": 0.55,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 9.81,
      "nacelleLower_x": 4.91,
      "nacelleLower_z": 1.69,
      "nacelleLower_length": 1.82,
      "nacelleLower_radius": 1.31,
      "nacelleLower_widthRatio": 1.21,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -20.24,
      "engineering_z": 0.05,
      "engineering_length": 6.81,
      "engineering_radius": 1.56,
      "engineering_widthRatio": 0.84,
      "engineering_skew": 0.53,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.82,
      "pylon_nacelleAftOffset": 0,
      "pylon_engineeringForeOffset": 0.44,
      "pylon_engineeringAftOffset": 0.11,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.18,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.01,
      "pylonLower_nacelleAftOffset": 0,
      "pylonLower_engineeringForeOffset": 0.23,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_thickness": 0.21,
      "boomLower_toggle": false,
      "pylonLower_midPointOffset": 0.1,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.36,
      "neck_primaryAftOffset": 0.39,
      "neck_engineeringForeOffset": 0.17,
      "neck_engineeringAftOffset": 0.07,
      "neck_thickness": 0.19,
      "neck_primaryThickness": 0.19,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -10,
      "primary_z": 0.79,
      "primary_radius": 6.01,
      "primary_thickness": 1.94,
      "primary_widthRatio": 1.74,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "HMAS ForkedTailedDevilCake"
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 10.73,
      "nacelle_x": 2.74,
      "nacelle_z": -1,
      "nacelle_length": 13.5,
      "nacelle_radius": 0.63,
      "nacelle_widthRatio": 2.44,
      "nacelle_rotation": -0.24,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 3.75,
      "nacelleLower_x": 1.03,
      "nacelleLower_z": 2.41,
      "nacelleLower_length": 12.89,
      "nacelleLower_radius": 2.2,
      "nacelleLower_widthRatio": 0.39,
      "nacelleLower_rotation": 1.57,
      "engineering_toggle": true,
      "engineering_y": -8.5,
      "engineering_z": 3.63,
      "engineering_length": 10.93,
      "engineering_radius": 1.63,
      "engineering_widthRatio": 1.05,
      "engineering_skew": -1.24,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.24,
      "pylon_nacelleAftOffset": 0.39,
      "pylon_engineeringForeOffset": 0.32,
      "pylon_engineeringAftOffset": 0.18,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.22,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0,
      "pylonLower_engineeringForeOffset": 0,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_thickness": 0.25,
      "boomLower_toggle": false,
      "pylonLower_midPointOffset": 0.1,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.48,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.36,
      "neck_primaryThickness": 0.36,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -3.13,
      "primary_z": 1.14,
      "primary_radius": 7.26,
      "primary_thickness": 2.76,
      "primary_widthRatio": 1.03,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Agameminonicon",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 7.62,
      "nacelle_x": 3.65,
      "nacelle_z": -1.84,
      "nacelle_length": 11.02,
      "nacelle_radius": 1.23,
      "nacelle_widthRatio": 1.45,
      "nacelle_rotation": -0.01,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 5.29,
      "nacelleLower_x": 1.82,
      "nacelleLower_z": 7.01,
      "nacelleLower_length": 14.58,
      "nacelleLower_radius": 1.19,
      "nacelleLower_widthRatio": 1.39,
      "nacelleLower_rotation": 0.01,
      "engineering_toggle": true,
      "engineering_y": -14.44,
      "engineering_z": 3.65,
      "engineering_length": 20.75,
      "engineering_radius": 1.89,
      "engineering_widthRatio": 1.05,
      "engineering_skew": -2.3,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.28,
      "pylon_nacelleAftOffset": 0.42,
      "pylon_engineeringForeOffset": 0.32,
      "pylon_engineeringAftOffset": 0.35,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.2,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.28,
      "pylonLower_nacelleAftOffset": 0.54,
      "pylonLower_engineeringForeOffset": 0.26,
      "pylonLower_engineeringAftOffset": 0.22,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.24,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.22,
      "neck_primaryAftOffset": 0.08,
      "neck_engineeringForeOffset": 0.29,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.24,
      "neck_primaryThickness": 0.24,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 0.91,
      "primary_z": 3.01,
      "primary_radius": 11.11,
      "primary_thickness": 3.35,
      "primary_widthRatio": 0.9,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Tortuga",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": false,
      "nacelle_y": 24.96,
      "nacelle_x": 0,
      "nacelle_z": -12.69,
      "nacelle_length": 7.99,
      "nacelle_radius": 0.61,
      "nacelle_widthRatio": 1.12,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 9.13,
      "nacelleLower_x": 2.85,
      "nacelleLower_z": 6.04,
      "nacelleLower_length": 15.1,
      "nacelleLower_radius": 1.49,
      "nacelleLower_widthRatio": 0.46,
      "nacelleLower_rotation": -0.46,
      "engineering_toggle": true,
      "engineering_y": -21.01,
      "engineering_z": 3.89,
      "engineering_length": 10.93,
      "engineering_radius": 1.69,
      "engineering_widthRatio": 0.98,
      "engineering_skew": -1.64,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.25,
      "pylon_nacelleAftOffset": 0.2,
      "pylon_engineeringForeOffset": 0.26,
      "pylon_engineeringAftOffset": 0.1,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.17,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.05,
      "pylonLower_nacelleAftOffset": 0.74,
      "pylonLower_engineeringForeOffset": 0.4,
      "pylonLower_engineeringAftOffset": 0.16,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.32,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.36,
      "neck_primaryThickness": 0.36,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -4.43,
      "primary_z": -2.22,
      "primary_radius": 12.29,
      "primary_thickness": 3.11,
      "primary_widthRatio": 0.56,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "USMC Taildragger",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 8.6,
      "nacelle_x": -2.06,
      "nacelle_z": -1.12,
      "nacelle_length": 12.23,
      "nacelle_radius": 1.18,
      "nacelle_widthRatio": 1.05,
      "nacelle_rotation": -0.38,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 10.73,
      "nacelleLower_x": 6.47,
      "nacelleLower_z": 4.87,
      "nacelleLower_length": 4.4,
      "nacelleLower_radius": 1.58,
      "nacelleLower_widthRatio": 0.39,
      "nacelleLower_rotation": -0.38,
      "engineering_toggle": true,
      "engineering_y": -27,
      "engineering_z": -0.81,
      "engineering_length": 25.95,
      "engineering_radius": 2.03,
      "engineering_widthRatio": 0.65,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.31,
      "pylon_nacelleAftOffset": 0,
      "pylon_engineeringForeOffset": 0.3,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,    
      "pylon_thickness": 0.59,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.04,
      "pylonLower_nacelleAftOffset": 0.14,
      "pylonLower_engineeringForeOffset": 0.62,
      "pylonLower_engineeringAftOffset": 0.06,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.29,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.17,
      "neck_primaryThickness": 0.17,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -8.9,
      "primary_z": -4.45,
      "primary_radius": 11.32,
      "primary_thickness": 4.5,
      "primary_widthRatio": 0.13,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Kittyhawk Class",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 18.73,
      "nacelle_x": 3.12,
      "nacelle_z": -6.33,
      "nacelle_length": 18.44,
      "nacelle_radius": 1.18,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 5.92,
      "nacelleLower_x": 1.62,
      "nacelleLower_z": 4.34,
      "nacelleLower_length": 15.17,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -27.92,
      "engineering_z": 7.6,
      "engineering_length": 14.52,
      "engineering_radius": 2,
      "engineering_widthRatio": 1,
      "engineering_skew": -1.04,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.09,
      "pylon_nacelleAftOffset": 0.78,
      "pylon_engineeringForeOffset": 0.55,
      "pylon_engineeringAftOffset": 0.09,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.26,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.46,
      "pylonLower_engineeringForeOffset": 0.29,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_thickness": 0.15,
      "boomLower_toggle": false,
      "pylonLower_midPointOffset": 0.1,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.68,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.36,
      "neck_primaryThickness": 0.36,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -7.16,
      "primary_z": 2.74,
      "primary_radius": 10.42,
      "primary_thickness": 3.06,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Cerberus"
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": -1.65,
      "nacelle_x": 2.45,
      "nacelle_z": -0.48,
      "nacelle_length": 6.78,
      "nacelle_radius": 0.44,
      "nacelle_widthRatio": 1.84,
      "nacelle_rotation": -0.3,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 1.64,
      "nacelleLower_x": 1.16,
      "nacelleLower_z": 1.41,
      "nacelleLower_length": 1.75,
      "nacelleLower_radius": 0.69,
      "nacelleLower_widthRatio": 1.18,
      "nacelleLower_rotation": 0.31,
      "engineering_toggle": true,
      "engineering_y": -2.28,
      "engineering_z": -0.12,
      "engineering_length": 5.26,
      "engineering_radius": 0.7,
      "engineering_widthRatio": 2.24,
      "engineering_skew": 1.36,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.17,
      "pylon_nacelleAftOffset": 0.62,
      "pylon_engineeringForeOffset": 0.55,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,    
      "pylon_thickness": 0.09,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.57,
      "pylonLower_engineeringForeOffset": 0.58,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_thickness": 0.06,
      "boomLower_toggle": false,
      "pylonLower_midPointOffset": 0.1,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.6,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.06,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.09,
      "neck_primaryThickness": 0.09,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 0.72,
      "primary_z": -0.97,
      "primary_radius": 4.21,
      "primary_thickness": 1.83,
      "primary_widthRatio": 0.23,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Shooting Star Class",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 14.04,
      "nacelle_x": 2.38,
      "nacelle_z": 0.06,
      "nacelle_length": 13.68,
      "nacelle_radius": 0.96,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0.71,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 13.27,
      "nacelleLower_x": 3.6,
      "nacelleLower_z": 0.06,
      "nacelleLower_length": 13.44,
      "nacelleLower_radius": 0.97,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0.71,
      "engineering_toggle": true,
      "engineering_y": -22.52,
      "engineering_z": 0.13,
      "engineering_length": 12.01,
      "engineering_radius": 1.63,
      "engineering_widthRatio": 1.05,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": false,
      "pylon_nacelleForeOffset": 0.1,
      "pylon_nacelleAftOffset": 0.65,
      "pylon_engineeringForeOffset": 0.63,
      "pylon_engineeringAftOffset": 0.14,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.33,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.1,
      "pylonLower_nacelleAftOffset": 0.65,
      "pylonLower_engineeringForeOffset": 0.63,
      "pylonLower_engineeringAftOffset": 0.06,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.33,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.32,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.25,
      "neck_engineeringAftOffset": 0.19,
      "neck_thickness": 0.78,
      "neck_primaryThickness": 0.78,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -3.7,
      "primary_z": -3.83,
      "primary_radius": 10.57,
      "primary_thickness": 2.63,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Vaccufortress",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 12.39,
      "nacelle_x": 3.18,
      "nacelle_z": 0.57,
      "nacelle_length": 21.1,
      "nacelle_radius": 0.44,
      "nacelle_widthRatio": 2.47,
      "nacelle_rotation": 0.49,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 12.39,
      "nacelleLower_x": 3.18,
      "nacelleLower_z": 1.57,
      "nacelleLower_length": 21.1,
      "nacelleLower_radius": 0.44,
      "nacelleLower_widthRatio": 2.47,
      "nacelleLower_rotation": -0.49,
      "engineering_toggle": true,
      "engineering_y": -22.95,
      "engineering_z": 0.12,
      "engineering_length": 19.41,
      "engineering_radius": 1.21,
      "engineering_widthRatio": 2.17,
      "engineering_skew": -1.51,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.34,
      "pylon_nacelleAftOffset": 0.58,
      "pylon_engineeringForeOffset": 0.34,
      "pylon_engineeringAftOffset": 0.04,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.29,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.34,
      "pylonLower_nacelleAftOffset": 0.58,
      "pylonLower_engineeringForeOffset": 0.34,
      "pylonLower_engineeringAftOffset": 0.04,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.29,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.5,
      "neck_primaryAftOffset": 0.04,
      "neck_engineeringForeOffset": 0.23,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.64,
      "neck_primaryThickness": 0.64,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -1.41,
      "primary_z": -3.38,
      "primary_radius": 11.38,
      "primary_thickness": 2.74,
      "primary_widthRatio": 0.63,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Nigelius Tufnel",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 17.66,
      "nacelle_x": 2.61,
      "nacelle_z": -2.34,
      "nacelle_length": 22.68,
      "nacelle_radius": 1.18,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 5.92,
      "nacelleLower_x": 1.62,
      "nacelleLower_z": 4.34,
      "nacelleLower_length": 15.17,
      "nacelleLower_radius": 1,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -27.92,
      "engineering_z": 7.6,
      "engineering_length": 14.52,
      "engineering_radius": 2,
      "engineering_widthRatio": 1,
      "engineering_skew": -1.04,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.11,
      "pylon_nacelleAftOffset": 0.74,
      "pylon_engineeringForeOffset": 0.63,
      "pylon_engineeringAftOffset": 0,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,    
      "pylon_thickness": 0.25,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.28,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.02,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.25,
      "boomLower_toggle": false,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.68,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.36,
      "neck_primaryThickness": 0.36,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -7.16,
      "primary_z": 2.74,
      "primary_radius": 10.71,
      "primary_thickness": 3.06,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Surprisius",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 2.74,
      "nacelle_x": 2.4,
      "nacelle_z": -2.65,
      "nacelle_length": 12.32,
      "nacelle_radius": 0.82,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 7.88,
      "nacelleLower_x": 1.18,
      "nacelleLower_z": -1.07,
      "nacelleLower_length": 3.71,
      "nacelleLower_radius": 0.47,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": false,
      "engineering_y": -3.51,
      "engineering_z": 0.34,
      "engineering_length": 18.62,
      "engineering_radius": 0.4,
      "engineering_widthRatio": 1.84,
      "engineering_skew": 0.74,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.23,
      "pylon_nacelleAftOffset": 0.47,
      "pylon_engineeringForeOffset": 0.03,
      "pylon_engineeringAftOffset": 0.03,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.16,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0,
      "pylonLower_nacelleAftOffset": 0.04,
      "pylonLower_engineeringForeOffset": 0.56,
      "pylonLower_engineeringAftOffset": 0,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_thickness": 0.18,
      "boomLower_toggle": false,
      "pylonLower_midPointOffset": 0.1,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.2,
      "neck_primaryThickness": 0.2,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 5.82,
      "primary_z": -1.04,
      "primary_radius": 9.92,
      "primary_thickness": 2.84,
      "primary_widthRatio": 0.06,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Lippisch Class"
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 10.84,
      "nacelle_x": 4.44,
      "nacelle_z": -0.8,
      "nacelle_length": 22.32,
      "nacelle_radius": 1.19,
      "nacelle_widthRatio": 1.9,
      "nacelle_rotation": 0.59,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 10.84,
      "nacelleLower_x": 4.49,
      "nacelleLower_z": 0.75,
      "nacelleLower_length": 22.32,
      "nacelleLower_radius": 0.81,
      "nacelleLower_widthRatio": 2.37,
      "nacelleLower_rotation": -0.81,
      "engineering_toggle": true,
      "engineering_y": -30.23,
      "engineering_z": 4.44,
      "engineering_length": 18.48,
      "engineering_radius": 2.3,
      "engineering_widthRatio": 1,
      "engineering_skew": -0.98,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.45,
      "pylon_engineeringForeOffset": 0.56,
      "pylon_engineeringAftOffset": 0.19,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.3,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.15,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.3,
      "neck_primaryThickness": 0.3,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -10,
      "primary_z": 0.5,
      "primary_radius": 12,
      "primary_thickness": 4,
      "primary_widthRatio": 1.21,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Edmontonius"
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 3.41,
      "nacelle_x": 4.39,
      "nacelle_z": -1.39,
      "nacelle_length": 13.79,
      "nacelle_radius": 0.84,
      "nacelle_widthRatio": 2.2,
      "nacelle_rotation": -0.52,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 5.12,
      "nacelleLower_x": 4.26,
      "nacelleLower_z": 0.88,
      "nacelleLower_length": 20.86,
      "nacelleLower_radius": 0.48,
      "nacelleLower_widthRatio": 2.37,
      "nacelleLower_rotation": -0.93,
      "engineering_toggle": true,
      "engineering_y": -15.92,
      "engineering_z": 0.47,
      "engineering_length": 8.56,
      "engineering_radius": 2.32,
      "engineering_widthRatio": 0.76,
      "engineering_skew": 1.02,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.21,
      "pylon_nacelleAftOffset": 0.45,
      "pylon_engineeringForeOffset": 0.56,
      "pylon_engineeringAftOffset": 0.19,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.18,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.44,
      "pylonLower_nacelleAftOffset": 0.44,
      "pylonLower_engineeringForeOffset": 0.28,
      "pylonLower_engineeringAftOffset": 0.19,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.2,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.15,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.18,
      "neck_primaryThickness": 0.18,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -3.81,
      "primary_z": 0.3,
      "primary_radius": 8.21,
      "primary_thickness": 3.39,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Tocino",
      "nacelle_lowerToggle": false,
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 17.55,
      "nacelle_x": 1.99,
      "nacelle_z": -4.69,
      "nacelle_length": 19.03,
      "nacelle_radius": 1.15,
      "nacelle_widthRatio": 1,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": false,
      "nacelleLower_y": 36,
      "nacelleLower_x": 2.25,
      "nacelleLower_z": -3.15,
      "nacelleLower_length": 10.8,
      "nacelleLower_radius": 0.9,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": 0,
      "engineering_toggle": true,
      "engineering_y": -18.41,
      "engineering_z": 3.1,
      "engineering_length": 16.46,
      "engineering_radius": 0.67,
      "engineering_widthRatio": 10,
      "engineering_skew": 0,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.29,
      "pylon_nacelleAftOffset": 0.54,
      "pylon_engineeringForeOffset": 0,
      "pylon_engineeringAftOffset": 0.09,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.19,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.3,
      "pylonLower_nacelleAftOffset": 0.3,
      "pylonLower_engineeringForeOffset": 0.3,
      "pylonLower_engineeringAftOffset": 0.3,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.14,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.56,
      "neck_primaryAftOffset": 0.05,
      "neck_engineeringForeOffset": 0.31,
      "neck_engineeringAftOffset": 0.43,
      "neck_thickness": 0.27,
      "neck_primaryThickness": 0.27,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -7.61,
      "primary_z": 0.46,
      "primary_radius": 8.1,
      "primary_thickness": 3.86,
      "primary_widthRatio": 1,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "ReadingRainbow",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": false,
      "nacelle_y": 18.2,
      "nacelle_x": 0,
      "nacelle_z": -9.25,
      "nacelle_length": 5.82,
      "nacelle_radius": 0.44,
      "nacelle_widthRatio": 1.12,
      "nacelle_rotation": 0,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 15.83,
      "nacelleLower_x": 3.24,
      "nacelleLower_z": 6.33,
      "nacelleLower_length": 20.55,
      "nacelleLower_radius": 1.09,
      "nacelleLower_widthRatio": 1.02,
      "nacelleLower_rotation": -0.34,
      "engineering_toggle": true,
      "engineering_y": -18.08,
      "engineering_z": 2.84,
      "engineering_length": 12.17,
      "engineering_radius": 1.48,
      "engineering_widthRatio": 0.98,
      "engineering_skew": -0.71,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": false,
      "pylon_nacelleForeOffset": 0.25,
      "pylon_nacelleAftOffset": 0.2,
      "pylon_engineeringForeOffset": 0.26,
      "pylon_engineeringAftOffset": 0.1,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,    
      "pylon_thickness": 0.12,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.21,
      "pylonLower_nacelleAftOffset": 0.68,
      "pylonLower_engineeringForeOffset": 0.25,
      "pylonLower_engineeringAftOffset": 0.11,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.25,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.08,
      "neck_thickness": 0.31,
      "neck_primaryThickness": 0.31,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 0.52,
      "primary_z": -2.12,
      "primary_radius": 11.65,
      "primary_thickness": 3.31,
      "primary_widthRatio": 0.56,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "USMC Blitzen",
      "nacelle_lowerToggle": false,
    },
    {
      "primary_toggle": true,
      "primary_y": 5.06,
      "primary_z": -1.66,
      "primary_radius": 11.65,
      "primary_thickness": 3.31,
      "primary_widthRatio": 0.56,
      "primary_pointiness": 0,
      "primary_segments": 64,
      "primary_bridgeThickness": 0.97,
      "primary_bridgeRadius": 0.69,
      "primary_bridgeWidthRatio": 0.83,
      "primary_bridgeZ": -0.17,
      "primary_bridgeY": 0.22,
      "primary_bridgeSegments": 64,
      "primary_notchAngle": 0,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.39,
      "neck_primaryAftOffset": 0.07,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.22,
      "neck_primaryThickness": 1.58,
      "neck_thickness": 1.58,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -18.28,
      "engineering_z": 2.53,
      "engineering_length": 17.59,
      "engineering_radius": 1.28,
      "engineering_widthRatio": 1.63,
      "engineering_skew": -2.2,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 0.75,
      "engineering_dishInset": 0.97,
      "nacelle_toggle": true,
      "nacelle_y": 15.82,
      "nacelle_x": 3.23,
      "nacelle_z": 0.25,
      "nacelle_length": 8.29,
      "nacelle_radius": 1.53,
      "nacelle_widthRatio": 0.65,
      "nacelle_rotation": 0,
      "pylon_toggle": false,
      "pylon_nacelleForeOffset": 0.25,
      "pylon_nacelleAftOffset": 0.2,
      "pylon_engineeringForeOffset": 0.26,
      "pylon_engineeringAftOffset": 0.1,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.12,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 15.83,
      "nacelleLower_x": 3.24,
      "nacelleLower_z": -0.01,
      "nacelleLower_length": 20.55,
      "nacelleLower_radius": 1.17,
      "nacelleLower_widthRatio": 0.92,
      "nacelleLower_rotation": 0.1,
      "boomLower_toggle": false,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.21,
      "pylonLower_nacelleAftOffset": 0.68,
      "pylonLower_engineeringForeOffset": 0.25,
      "pylonLower_engineeringAftOffset": 0.26,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.25,
      "name": "Vowelprise",
      "nacelle_lowerToggle": false,
      "engineering_segments": null,
      "nacelle_segments": null,
      "nacelle_skew": null,
      "nacelleLower_segments": null,
      "nacelleLower_skew": null
    },
    {
      "primary_toggle": true,
      "primary_y": -2.62,
      "primary_z": 1.42,
      "primary_radius": 8.56,
      "primary_thickness": 4.38,
      "primary_widthRatio": 1.03,
      "primary_pointiness": 0,
      "primary_bridgeThickness": 1.19,
      "primary_bridgeRadius": 0.55,
      "primary_bridgeWidthRatio": 0.72,
      "primary_bridgeZ": 0.01,
      "primary_bridgeY": 0,
      "primary_notchAngle": 0,
      "neck_toggle": false,
      "neck_primaryForeOffset": 0.22,
      "neck_primaryAftOffset": 0.08,
      "neck_engineeringForeOffset": 0.29,
      "neck_engineeringAftOffset": 0,
      "neck_primaryThickness": 0.22,
      "neck_thickness": 0.22,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "engineering_toggle": true,
      "engineering_y": -21.24,
      "engineering_z": 1.05,
      "engineering_length": 7.85,
      "engineering_radius": 1.23,
      "engineering_widthRatio": 1.81,
      "engineering_skew": 0.9,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "nacelle_toggle": true,
      "nacelle_y": 12.6,
      "nacelle_x": 5.03,
      "nacelle_z": -6.67,
      "nacelle_length": 17.43,
      "nacelle_radius": 1.12,
      "nacelle_widthRatio": 1.66,
      "nacelle_rotation": -1.27,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.4,
      "pylon_nacelleAftOffset": 0.25,
      "pylon_engineeringForeOffset": 0.35,
      "pylon_engineeringAftOffset": 0.1,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.27,
      "pylon_thickness": 0.18,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 3.35,
      "nacelleLower_x": 2.08,
      "nacelleLower_z": 2.53,
      "nacelleLower_length": 17.56,
      "nacelleLower_radius": 0.75,
      "nacelleLower_widthRatio": 2.33,
      "nacelleLower_rotation": -0.6,
      "boomLower_toggle": true,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.51,
      "pylonLower_nacelleAftOffset": 0.23,
      "pylonLower_engineeringForeOffset": 0.08,
      "pylonLower_engineeringAftOffset": 0.23,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.39,
      "name": "AJaegerlex",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": -2.49,
      "nacelle_x": 2.2,
      "nacelle_z": 0.18,
      "nacelle_length": 15.69,
      "nacelle_radius": 1.04,
      "nacelle_widthRatio": 0.59,
      "nacelle_rotation": 0.55,
      "nacelleLower_toggle": true,
      "nacelleLower_y": -2.49,
      "nacelleLower_x": 2.2,
      "nacelleLower_z": 1.61,
      "nacelleLower_length": 15.69,
      "nacelleLower_radius": 1.01,
      "nacelleLower_widthRatio": 0.59,
      "nacelleLower_rotation": -0.54,
      "engineering_toggle": true,
      "engineering_y": -8.5,
      "engineering_z": -1.42,
      "engineering_length": 6.5,
      "engineering_radius": 0.54,
      "engineering_widthRatio": 5.25,
      "engineering_skew": -0.62,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0,
      "pylon_nacelleAftOffset": 0.54,
      "pylon_engineeringForeOffset": 0.59,
      "pylon_engineeringAftOffset": 0.19,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.23,
      "pylonLower_toggle": false,
      "pylonLower_nacelleForeOffset": 0.76,
      "pylonLower_nacelleAftOffset": 0.27,
      "pylonLower_engineeringForeOffset": 0.52,
      "pylonLower_engineeringAftOffset": 0.08,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.17,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.53,
      "neck_primaryAftOffset": 0.31,
      "neck_engineeringForeOffset": 0.36,
      "neck_engineeringAftOffset": 0.35,
      "neck_thickness": 0.62,
      "neck_primaryThickness": 0.62,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": 2.88,
      "primary_z": -0.68,
      "primary_radius": 5.84,
      "primary_thickness": 2.68,
      "primary_widthRatio": 1.3,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Conspiratorial Raven",
      "nacelle_lowerToggle": false
    },
    {
      "nacelle_toggle": true,
      "nacelle_y": 9.61,
      "nacelle_x": 5.43,
      "nacelle_z": -4.15,
      "nacelle_length": 6.71,
      "nacelle_radius": 0.62,
      "nacelle_widthRatio": 2.31,
      "nacelle_rotation": 0.49,
      "nacelleLower_toggle": true,
      "nacelleLower_y": 8.98,
      "nacelleLower_x": 5.43,
      "nacelleLower_z": 4.16,
      "nacelleLower_length": 11.37,
      "nacelleLower_radius": 0.73,
      "nacelleLower_widthRatio": 1,
      "nacelleLower_rotation": -0.75,
      "engineering_toggle": true,
      "engineering_y": -11.86,
      "engineering_z": 2.07,
      "engineering_length": 7.87,
      "engineering_radius": 1.1,
      "engineering_widthRatio": 1.21,
      "engineering_skew": -1.43,
      "engineering_undercut": 0.5,
      "engineering_undercutStart": 0.6,
      "engineering_dishRadius": 1,
      "engineering_dishInset": 0,
      "pylon_toggle": true,
      "pylon_nacelleForeOffset": 0.16,
      "pylon_nacelleAftOffset": 0.67,
      "pylon_engineeringForeOffset": 0.26,
      "pylon_engineeringAftOffset": 0.47,
      "pylon_engineeringZOffset": 0.0,
      "pylon_midPointOffset": 0.1,
      "pylon_thickness": 0.26,
      "pylonLower_toggle": true,
      "pylonLower_nacelleForeOffset": 0.24,
      "pylonLower_nacelleAftOffset": 0.65,
      "pylonLower_engineeringForeOffset": 0.51,
      "pylonLower_engineeringAftOffset": 0.24,
      "pylonLower_engineeringZOffset": 0.0,
      "pylonLower_midPointOffset": 0.1,
      "pylonLower_thickness": 0.06,
      "boomLower_toggle": false,
      "neck_toggle": true,
      "neck_primaryForeOffset": 0.56,
      "neck_primaryAftOffset": 0,
      "neck_engineeringForeOffset": 0.31,
      "neck_engineeringAftOffset": 0,
      "neck_thickness": 0.16,
      "neck_primaryThickness": 0.16,
      "neck_foretaper": 1,
      "neck_afttaper": 1,
      "primary_toggle": true,
      "primary_y": -4.16,
      "primary_z": -0.36,
      "primary_radius": 5.68,
      "primary_thickness": 2.75,
      "primary_widthRatio": 0.12,
      "primary_pointiness": 0.0,
      "primary_bridgeThickness":  1.0,
      "primary_bridgeRadius": 0.2,
      "primary_bridgeWidthRatio": 1,
      "primary_bridgeZ": 0.0,
      "primary_bridgeY": 0.0,
      "primary_notchAngle": 0,
      "name": "Mosquito Class",
      "nacelle_lowerToggle": false,
    }
  ]
  export default ships;